<script setup>
import moment from "moment";
moment.locale("id");
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div class="container-fluid mt-5 py-3" v-if="sioID == null">
          <h4
            class="pt-5 text-center"
            style="
              color: #dd3737;
              font-family: Inter-Medium;
              font-style: normal;
              font-weight: bold;
              font-size: 2.5rem;
            "
          >
            Anda belum melakukan pengajuan Certificate of CMS Compliance (CoC)!
          </h4>
          <p class="text-center">
            Silahkan lengkapi form berikut melakuan pengajuan Certificate of CMS
            Compliance (CoC)
          </p>
          <div
            class="body-form-wizard container bg-white border border-1 rounded"
          >
            <div class="steps d-flex">
              <div class="step w-100 p-4">
                <h4
                  style="
                    font-size: 2rem;
                    line-height: 1.5rem;
                    font-family: Inter-Bold;
                  "
                  class="mb-3 mt-3 text-center"
                >
                  Tipe Certificate of CMS Compliance (CoC)
                </h4>
                <p class="mb-4 text-center">
                  Silahkan pilih tipe Certificate of CMS Compliance (CoC) yang
                  akan diajukan.
                </p>
                <div class="grid mt-1">
                  <div class="col">
                    <div class="checkbox fs-6">
                      <input
                        type="radio"
                        name="coc"
                        value="1"
                        id="coc-1"
                        v-model="formValues.type"
                      />
                      <label for="coc-1" class="w-100 p-3"
                        >Pengajuan Certificate of CMS Compliance (CoC)
                        baru</label
                      >
                    </div>
                  </div>
                  <div class="col">
                    <div class="checkbox fs-6">
                      <input
                        type="radio"
                        name="coc"
                        value="2"
                        id="coc-2"
                        v-model="formValues.type"
                      />
                      <label for="coc-2" class="w-100 p-3"
                        >Pergantian Penanggung Jawab Operasional (PJO)</label
                      >
                    </div>
                  </div>
                  <div class="col">
                    <div class="checkbox fs-6">
                      <input
                        type="radio"
                        name="coc"
                        value="3"
                        id="coc-3"
                        v-model="formValues.type"
                      />
                      <label for="coc-3" class="w-100 p-3"
                        >Update Data Certificate of CMS Compliance (CoC)</label
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="step w-100 p-4">
                <!-- <h4 style="font-size: 2rem; line-height: 1.5rem; font-family: Inter-Bold;" class="mb-3 mt-3">{{ formValues.type == 1 ? 'Pengajuan CoC Baru' : formValues.type == 2 ? 'Pergantian PJO' : formValues.type == 3 ? 'Update Data CoC' : '' }}</h4>
              <p class="fs-6">Silahkan lengkapi form berikut melakuan {{ formValues.type == 1 ? 'pengajuan CoC baru' : formValues.type == 2 ? 'pergantian PJO' : formValues.type == 3 ? 'update data CoC' : '' }}</p> -->
                <div class="row mb-1">
                  <div class="col-md-12">
                    <p
                      class="text-start"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      Informasi PJO
                    </p>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-4">
                    <label
                      for="namaPjo"
                      class="form-label text-start fs-8 fw-bold"
                    >
                      Nama PJO <span class="text-danger fs-6">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="namaPjo"
                      placeholder="Masukkan Nama PJO"
                      v-model="formValues.namaPjo"
                    />
                  </div>
                  <div class="col-md-4">
                    <label
                      for="jabatanPjo"
                      class="form-label text-start fs-8 fw-bold"
                    >
                      Jabatan PJO <span class="text-danger fs-6">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="jabatanPjo"
                      placeholder="Masukkan Jabatan PJO"
                      v-model="formValues.jabatanPjo"
                    />
                  </div>
                  <div class="col-md-4">
                    <label
                      for="tandaTangan"
                      class="form-label fs-8 fw-bold text-start"
                    >
                      Tanda Tangan PJO (png, jpg, jpeg)
                      <span class="text-danger fs-6">*</span>
                    </label>
                    <div class="input-group mb-1">
                      <input
                        type="file"
                        ref="tandaTanganPjo"
                        accept="image/png, image/jpg, image/jpeg"
                        class="form-control fs-9"
                        id="inputGroupFile04"
                        @change="handleChangeFileSIO('tandaTanganPjo')"
                        aria-describedby="inputGroupFileAddon04"
                        aria-label="Upload"
                      />
                      <button
                        class="btn btn-outline-secondary fs-9 border border-start-0"
                        type="button"
                        id="inputGroupFileAddon04"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-cloud-arrow-up"
                          style="color: #000000"
                        />
                      </button>
                    </div>
                    <div
                      v-if="validasiFile.sizeTtdPjo"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ukuran file melebihi batas (Max: {{ max_file_size }}MB)
                    </div>
                    <div
                      v-if="validasiFile.typeTtdPjo"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ekstensi file tidak sesuai, Mohon tambahkan file Gambar
                      png, jpg, jpeg
                    </div>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-md-4">
                    <label
                      for="fileSertifikat"
                      class="form-label fs-8 fw-bold text-start"
                    >
                      File Sertifikat Kompetensi Calon PJO(.pdf)<span
                        class="text-danger fs-6"
                        >*</span
                      >
                    </label>
                    <div class="input-group mb-1">
                      <input
                        type="file"
                        ref="fileSertifikatPjo"
                        accept=".pdf"
                        class="form-control fs-9"
                        id="inputGroupFile04"
                        @change="handleChangeFileSIO('fileSertifikatPjo')"
                        aria-describedby="inputGroupFileAddon04"
                        aria-label="Upload"
                        multiple
                      />
                      <button
                        class="btn btn-outline-secondary fs-9 border border-start-0"
                        type="button"
                        id="inputGroupFileAddon04"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-cloud-arrow-up"
                          style="color: #000000"
                        />
                      </button>
                    </div>
                    <div
                      v-if="validasiFile.sizeSertifikatPjo"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ukuran file melebihi batas (Max: {{ max_file_size_sertifikat }}MB)
                    </div>
                    <div
                      v-if="validasiFile.typeSertifikatPjo"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ekstensi file tidak sesuai, Mohon tambahkan file pdf
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label
                      for="sertifikatPjo"
                      class="form-label text-start fs-8 fw-bold"
                    >
                      Nomor Sertifikat Pengawas Operasional
                      <span class="text-danger fs-6">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="sertifikatPjo"
                      placeholder="Masukkan Nomor Sertifikat PJO"
                      v-model="formValues.nomorSertifikatPjo"
                    />
                  </div>
                </div>
                <div class="row mb-1">
                  <div class="col-md-12">
                    <p
                      class="text-start"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      Informasi Pimpinan Tertinggi Perusahaan
                    </p>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-md-4">
                    <label
                      for="namaAtasan"
                      class="form-label text-start fs-8 fw-bold"
                    >
                      Nama Direksi <span class="text-danger fs-6">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="namaAtasan"
                      placeholder="Masukkan Nama Atasan"
                      v-model="formValues.namaAtasan"
                    />
                  </div>
                  <div class="col-md-4">
                    <label
                      for="jabatanAtasan"
                      class="form-label text-start fs-8 fw-bold"
                    >
                      Jabatan Direksi <span class="text-danger fs-6">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="jabatanAtasan"
                      placeholder="Masukkan Jabatan Atasan"
                      v-model="formValues.jabatanAtasan"
                    />
                  </div>
                  <div class="col-md-4">
                    <label
                      for="tandaTangan"
                      class="form-label fs-8 fw-bold text-start"
                    >
                      Tanda Tangan Direksi (png, jpg, jpeg)
                      <span class="text-danger fs-6">*</span>
                    </label>
                    <div class="input-group mb-1">
                      <input
                        type="file"
                        ref="tandaTanganAtasan"
                        accept="image/png, image/jpg, image/jpeg"
                        class="form-control fs-9"
                        id="inputGroupFile04"
                        @change="handleChangeFileSIO('tandaTanganAtasan')"
                        aria-describedby="inputGroupFileAddon04"
                        aria-label="Upload"
                      />
                      <button
                        class="btn btn-outline-secondary fs-9 border border-start-0"
                        type="button"
                        id="inputGroupFileAddon04"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-cloud-arrow-up"
                          style="color: #000000"
                        />
                      </button>
                    </div>
                    <div
                      v-if="validasiFile.sizeTtdAtasan"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ukuran file melebihi batas (Max: {{ max_file_size }}MB)
                    </div>
                    <div
                      v-if="validasiFile.typeTtdAtasan"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ekstensi file tidak sesuai, Mohon tambahkan file Gambar
                      png, jpg, jpeg
                    </div>
                  </div>
                </div>

                <!-- </div> -->
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center p-4">
              <button
                @click="movePage(-1)"
                class="btn btn_cari fs-8 fw-bold w-25"
                :disabled="currentPage === 1"
              >
                Previous
              </button>
              <button
                @click="handleButtonClick"
                class="btn btn_cari fs-8 fw-bold w-25"
                :disabled="!formValues.type"
              >
                {{
                  currentPage === 2 || formValues.type == 3
                    ? "Ajukan CoC"
                    : "Next"
                }}
              </button>
            </div>
          </div>
        </div>

        <!-- View ketika sudah ada CoC ID -->
        <div class="container-fluid py-3" v-if="sioID != null">
          <!-- <img :src="showttd" style="height:3rem" /> -->
          <h4
            style="
              color: #dd3737;
              font-family: 'Inter-Medium';
              font-style: normal;
              font-weight: bold;
              font-size: 2.5rem;
            "
          >
            Pra-Presentasi PJP Baru
          </h4>
          <p class="text-secondary">
            Lengkapi dokumen persyaratan Pra-Pelaksanaan
          </p>
          <div class="row mb-2">
            <div class="col-md-4 d-flex align-items-center">
              <div class="d-flex">
                <div style="margin-right: 1rem">
                  <font-awesome-icon
                    :icon="`fa-solid ${dataStatus?.icon}`"
                    style="height: 3rem"
                    :style="`color: ${dataStatus?.color}`"
                  />
                </div>
                <div class="row">
                  <div class="w-100">
                    <p
                      class="mb-1"
                      style="font-size: 2rem; font-family: 'Inter-Bold'"
                      :style="{
                        'line-height':
                          status == 8 || status == 7 ? '2.5rem' : '1.5rem',
                      }"
                    >
                      {{ dataStatus?.name }}
                    </p>
                    <div
                      v-if="
                        status == 0 ||
                        status == 1 ||
                        status == 2 ||
                        status == 5 ||
                        status == 6 ||
                        status == 7 ||
                        status == -3 ||
                        status == -4
                      "
                      style="font-size: 1rem"
                      class="text-secondary"
                    >
                      {{ dataStatus?.description }}
                    </div>
                    <div v-if="status == 3">
                      <p>
                        Masa berlaku CoC:
                        {{ moment(masaBerlaku).format("DD-MM-YYYY") }}
                      </p>
                      <div
                        class="d-flex gap-2"
                        v-if="formValues.type === 1 || formValues.type === 3"
                      >
                        <button
                          class="btn btn-success"
                          @click="changeType(changeTypeEnum.PERGANTIAN)"
                        >
                          Pergantian PJO
                        </button>
                        <button
                          v-if="isExpiringSoon"
                          class="btn btn-info text-white"
                          @click="changeType(changeTypeEnum.PERPANJANG)"
                        >
                          Perpanjang CoC
                        </button>
                      </div>
                    </div>
                    <div
                      v-else-if="
                        status == -4
                      "
                    >
                      <button
                        class="btn btn-info"
                        @click="changeType(changeTypeEnum.PERPANJANG)"
                      >
                        Perpanjang CoC
                      </button>
                    </div>
                    <div
                      v-else-if="status == 8"
                      style="font-size: 1rem"
                      class="text-secondary"
                    >
                      <div
                        style="
                          white-space: pre-line;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          display: -webkit-box;
                          -webkit-box-orient: vertical;
                          -webkit-line-clamp: 4;
                        "
                      >
                        {{ alasan }}
                      </div>
                      <p class="pb-0 pt-2 m-0">
                        Silahkan update profile perusahaan anda
                        <a href="/profile">disini</a>
                      </p>
                    </div>
                    <div v-else-if="status == 7 && (formValues.type === 2 || formValues.type === 1)">
                      <button
                        class="btn btn-danger"
                        @click="changeType(changeTypeEnum.UPDATEDATA)"
                      >
                        Update data CoC
                      </button>
                      &nbsp;&nbsp;<button
                        class="btn btn-success"
                        @click="changeType(changeTypeEnum.PERGANTIAN)"
                      >
                        Pergantian PJO
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <table
                class="table w-100 rounded table-borderless"
                style="overflow: hidden; font-family: 'Inter-Regular', serif"
              >
                <thead
                  style="
                    font-family: 'Inter-Regular', serif;
                    line-height: 24px;
                    color: #28293d;
                  "
                >
                  <tr class="table-danger" style="max-height: 5vh">
                    <th class="p-2 text-nowrap fs-8" style="width: 25%">
                      <b>Status</b>
                    </th>
                    <th class="p-2 text-nowrap fs-8" style="width: 75%">
                      <b>Keterangan</b>
                    </th>
                  </tr>
                </thead>
                <tbody class="fs-9">
                  <tr v-for="(data, index) in listStatus" :key="index">
                    <td
                      class="align-items-center"
                      :class="{ 'table-secondary': index % 2 == 1 }"
                    >
                      <span
                        class="p-1 rounded text-white mx-auto"
                        :style="`background-color: ${data.color};`"
                        >{{ data.name }}</span
                      >
                    </td>
                    <td :class="{ 'table-secondary': index % 2 == 1 }">
                      {{ data.description }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="(status == 0 || status == -3) && formValues.type != 3">
              <button
                class="btn btn-danger fs-6 mb-0"
                style="text-decoration: none; font-weight: 700; cursor: pointer"
                data-bs-toggle="modal"
                data-bs-target="#editKelengkapan"
              >
                <font-awesome-icon icon="fa-solid fa-edit" />&nbsp;Edit
                Kelengkapan
              </button>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-8">
              <h3 class="text-slate-500 text-3xl font-inter font-bold">
                {{ kontraktorName }} ({{
                  formValues.type == 1
                    ? "Pengajuan CoC baru"
                    : formValues.type == 2
                    ? "Pergantian PJO"
                    : formValues.type == 3
                    ? "Update Data CoC"
                    : ""
                }})
              </h3>
            </div>
            <div
              class="col-md-4 d-flex justify-content-end"
              v-if="formValues.type != 3"
              style="height: fit-content"
            >
              <span
                class="text-secondary rounded p-2"
                style="background-color: #ffd9d9"
                >File Terpenuhi :
                <b class="text-danger"
                  >{{ jumlahFileTerpenuhi }}/{{ jumlahFile }}</b
                ></span
              >
            </div>
          </div>
          <div class="row" v-if="formValues.type != 3">
            <div class="row mb-2">
              <div
                class="col-md-1 d-flex justify-content-center align-items-start"
              >
                &nbsp;
              </div>
              <div class="col-md-11">
                <div class="row p-2">
                  <div
                    class="col-md-1 d-flex justify-content-center align-items-center"
                  >
                    &nbsp;
                  </div>
                  <div class="col-md-4 d-flex align-items-center">Dokumen</div>
                  <div class="col-md-1 align-items-center">Submit</div>
                  <div class="col-md-2 align-items-center">Status</div>
                </div>
              </div>
            </div>

            <div class="row mb-4" v-for="ld in listDokumen" :key="ld.id">
              <div
                class="col-md-1 d-flex justify-content-center align-items-start"
              >
                <span
                  class=""
                  style="font-size: 2rem; color: #dd3737; margin-left: 2rem"
                  >{{ ld.id }}</span
                >
              </div>
              <div class="col-md-11">
                <div class="row border rounded p-2 bg-white">
                  <div
                    class="col-md-1 d-flex justify-content-center align-items-center"
                  >
                    <!-- <span> -->
                    <font-awesome-icon
                      icon="fa-solid fa-circle-exclamation text-secondary fa-xl"
                      style="font-size: 2rem; color: #ffcc00"
                      class="text-center"
                      v-if="ld.statusFile === false && ld.reason != ''"
                    />
                    <font-awesome-icon
                      icon="fa-solid fa-square-check text-secondary fa-xl"
                      style="font-size: 2rem; color: #929292"
                      class="text-center"
                      v-else-if="ld.statusFile === false && ld.reason == ''"
                    />
                    <font-awesome-icon
                      icon="fa-solid fa-square-check text-secondary fa-xl"
                      style="font-size: 2rem; color: #0c8953"
                      class="text-center"
                      v-else-if="ld.statusFile === true"
                    />
                    <!-- </span> -->
                  </div>
                  <div class="col-md-4 d-flex align-items-center">
                    <span class="align-middle"
                      >{{ ld.label }}
                      <!-- <i v-if="ld.id==7" class="text-danger fs-8">(Tidak wajib diisi)</i> -->
                      <i class="text-danger fs-4"> *</i>
                    </span>
                  </div>
                  <div class="col-md-1 d-flex align-items-center text-center">
                    <p v-if="createdSio != null" class="text-black fs-9 mt-3">
                      {{ moment(createdSio).format("DD MMM YYYY") }} <br />
                      {{ moment(createdSio).format("HH:mm:ss") + " WIB" }}
                    </p>
                  </div>
                  <div class="col-md-2 d-flex align-items-center">
                    <p
                      v-if="status == 1"
                      class="fs-7 mt-3"
                      style="color: #ec8a29"
                    >
                      Under Review <br />
                      by Admin
                    </p>
                    <p
                      v-if="
                        status == -3 && ld.id <= 5 && ld.statusFile == false
                      "
                      class="fs-7 mt-3"
                      style="color: #df4d20"
                    >
                      Need Revision <br />
                      {{
                        ld.updatedAt != null
                          ? moment(ld.updatedAt).format("DD/MMM/YYYY")
                          : null
                      }}
                      <br />
                      {{
                        ld.updatedAt != null
                          ? moment(ld.updatedAt).format("HH:mm") + " WIB"
                          : null
                      }}
                    </p>
                    <p
                      v-if="
                        status == -3 && ld.id == 6 && ld.statusFile == false
                      "
                      class="fs-7 mt-3"
                      style="color: #df4d20"
                    >
                      Need Revision <br />
                      {{
                        reasondata != null &&
                        reasondata.reasonDocumentDate != null
                          ? moment(reasondata.reasonDocumentDate).format(
                              "DD/MMM/YYYY"
                            )
                          : null
                      }}
                      <br />
                      {{
                        reasondata != null &&
                        reasondata.reasonDocumentDate != null
                          ? moment(reasondata.reasonDocumentDate).format(
                              "HH:mm"
                            ) + " WIB"
                          : null
                      }}
                    </p>
                    <!-- <p v-if="status==-3&&ld.id==7&&ld.statusFile==false" class="fs-7 mt-3" style="color: #df4d20;">Need Revision <br/> {{ reasondata != null && reasondata.reasonImkpDate != null ? moment(reasondata.reasonImkpDate).format("DD/MMM/YYYY") : null }} <br> {{ reasondata != null && reasondata.reasonImkpDate != null ? moment(reasondata.reasonImkpDate).format("HH:mm")  + 'WIB' : null }}</p> -->
                    <p
                      v-if="
                        status == 2 ||
                        status == 3 ||
                        status == 5 ||
                        status == 6 ||
                        status == 7
                      "
                      class="fs-7 mt-3"
                      style="color: #b99b22"
                    >
                      Document Complete <br />
                      {{
                        documentComplete != null
                          ? moment(documentComplete).format("DD/MMM/YYYY")
                          : null
                      }}
                      <br />
                      {{
                        documentComplete != null
                          ? moment(documentComplete).format("HH:mm") + " WIB"
                          : null
                      }}
                    </p>
                  </div>
                  <div class="col-md-2 d-flex align-items-center">
                    <div class="row">
                      <a
                        v-if="
                          status == -3 &&
                          ld.statusFile === false &&
                          ld.reason != ''
                        "
                        @click="lihatCatatan(ld.reason)"
                        style="
                          text-decoration: none;
                          color: #dd3737;
                          font-family: 'Inter-Bold';
                        "
                        class="fs-7 cursor-pointer"
                        data-bs-toggle="modal"
                        data-bs-target="#modalCatatan"
                      >
                        <font-awesome-icon icon="fa-solid fa-comment-dots" />
                        Lihat Catatan
                      </a>
                      <a
                        v-else-if="
                          ld.id == 6 &&
                          ld.statusFile === false &&
                          reasondata != null &&
                          reasondata.reasonDocument != null &&
                          reasondata.reasonDocument != ''
                        "
                        @click="lihatCatatan(reasondata.reasonDocument)"
                        style="
                          text-decoration: none;
                          color: #dd3737;
                          font-family: 'Inter-Bold';
                        "
                        class="fs-7 cursor-pointer"
                        data-bs-toggle="modal"
                        data-bs-target="#modalCatatan"
                      >
                        Lihat Catatan
                      </a>
                      <!-- <a v-else-if="ld.id==7&&ld.statusFile===false&&(reasondata!=null&&reasondata.reasonImkp!=null&&reasondata.reasonImkp!='')" @click="lihatCatatan(reasondata.reasonImkp)" style="text-decoration: none;color: #dd3737;font-family: 'Inter-Bold';" class="fs-7 pointer" data-bs-toggle="modal" data-bs-target="#modalCatatan">
                      Lihat Catatan
                    </a> -->

                      <div
                        v-if="
                          ld.id >= 3 &&
                          ld.id <= 5 &&
                          ld.statusFile === false &&
                          (ld.attachment == null || ld.attachment == '') &&
                          ld.idForm != null
                        "
                      >
                        <a
                          @click="downloadTemplate(ld.id)"
                          class="fs-8 fw-bold text-danger cursor-pointer"
                          style="
                            margin-bottom: 0;
                            margin-top: 1rem;
                            text-decoration: none;
                          "
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-file-arrow-down"
                          />
                          Download Template </a
                        ><br />
                        <a
                          @click="popUploadFileDokumen(ld.id, ld.idForm)"
                          class="fs-8 fw-bold text-danger cursor-pointer"
                          style="
                            margin-bottom: 0;
                            margin-top: 1rem;
                            text-decoration: none;
                          "
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal345"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-cloud-arrow-up"
                          />
                          Upload Dokumen
                        </a>
                      </div>
                    </div>
                    <div v-if="status == 2">
                      <img
                        src="@/assets/icons/verified.png"
                        alt=""
                        style="width: 100%; height: auto; margin-top: 0px"
                      /><br />
                    </div>
                  </div>
                  <div
                    class="col-md-2 d-flex justify-content-center align-items-center"
                  >
                    <button
                      type="button"
                      class="btn btn_eform rounded border w-100"
                      @click="toForm(ld.linkForm)"
                      v-if="
                        ld.statusFile === false &&
                        ld.type == 'form' &&
                        status == 0
                      "
                    >
                      Isi e-Form
                    </button>
                    <button
                      type="button"
                      class="btn btn_eform rounded border w-100"
                      @click="toForm(ld.linkForm)"
                      v-else-if="
                        ld.statusFile === false &&
                        ld.type == 'formUpload' &&
                        status == 0 &&
                        ld.idForm == null
                      "
                    >
                      Isi & Upload
                    </button>
                    <button
                      type="button"
                      class="btn btn_eform rounded border w-100"
                      v-else-if="
                        ld.type == 'upload' && (status == 0 || status == -3)
                      "
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                    >
                      Upload
                    </button>
                    <button
                      type="button"
                      class="btn btn_eform rounded border w-100"
                      @click="toForm(ld.linkForm)"
                      v-if="
                        ld.type == 'form' &&
                        (status == 0 || status == -3) &&
                        ld.reason == '' &&
                        ld.statusFile === true
                      "
                    >
                      Edit e-Form
                    </button>
                    <button
                      type="button"
                      class="btn btn_eform rounded border w-100"
                      @click="toForm(ld.linkForm)"
                      v-if="
                        ld.type == 'formUpload' &&
                        (status == 0 || status == -3) &&
                        ld.reason == '' &&
                        ld.idForm != null
                      "
                    >
                      Edit e-Form
                    </button>
                    <button
                      type="button"
                      class="btn btn_eform rounded border w-100"
                      @click="toForm(ld.linkForm)"
                      v-if="
                        ld.statusFile === false &&
                        ld.reason != '' &&
                        (ld.type == 'form' || ld.type == 'formUpload') &&
                        status == -3
                      "
                    >
                      Update e-Form
                    </button>
                    <button
                      type="button"
                      class="btn btn_eform rounded border w-100"
                      @click="toForm(ld.linkForm)"
                      v-if="
                        ld.statusFile === true &&
                        ld.type == 'form' &&
                        (status == 1 ||
                          status == 2 ||
                          status == 3 ||
                          status == 5 ||
                          status == 6 ||
                          status == 7)
                      "
                    >
                      Lihat e-Form
                    </button>
                    <button
                      type="button"
                      class="btn btn_eform rounded border w-100"
                      @click="toForm(ld.linkForm)"
                      v-if="
                        ld.type == 'formUpload' &&
                        (status == 1 ||
                          status == 2 ||
                          status == 3 ||
                          status == 5 ||
                          status == 6 ||
                          status == 7)
                      "
                    >
                      Lihat e-Form
                    </button>
                  </div>
                </div>
                <div v-if="ld.attachment === undefined">
                  <div
                    class="row border rounded p-2 bg-white"
                    v-if="(ld.id == 1 || ld.id == 2) && ld.statusFile == true"
                  >
                    <div class="col-md-10"></div>
                    <div
                      class="col-md-2 d-flex justify-content-center align-items-center"
                    >
                      <a
                        style="
                          font-family: 'Inter-Bold';
                          font-size: 1.2rem;
                          color: #dd3737;
                          cursor: pointer;
                        "
                        @click="
                          redirectToLink(
                            `/printDokumenForm${ld.id}/`,
                            ld.idForm
                          )
                        "
                        class="text-danger text-decoration-none cursor-pointer"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-download"
                          style=""
                        />
                      </a>
                    </div>
                  </div>
                  <div
                    v-for="(a, idx) in ld.attachment"
                    :key="idx"
                    class="row border rounded p-2 bg-white"
                  >
                    <div
                      class="col-md-1 d-flex justify-content-center align-items-center"
                    >
                      &nbsp;
                    </div>
                    <div class="col-md-9 d-flex align-items-center">
                      <span class="align-middle">{{ a }}</span>
                    </div>
                    <div
                      class="col-md-2 d-flex justify-content-center align-items-center"
                      v-if="status == 0"
                    >
                      <a
                        @click="removeFile(ld.id, ld.realFileName, ld.idForm)"
                        class="text-danger text-decoration-none cursor-pointer"
                        >Remove</a
                      >
                    </div>
                    <div
                      class="col-md-2 d-flex justify-content-center align-items-center"
                      v-if="status == 1"
                    >
                      <a
                        @click="downloadFile(ld.realFileName)"
                        class="text-danger text-decoration-none cursor-pointer"
                        v-if="ld.realFileName != null && ld.realFileName != ''"
                        >Download</a
                      >
                    </div>
                  </div>
                </div>
                <!-- if file more than one -->
                <div v-else>
                  <div
                    class="row border rounded p-2 bg-white"
                    v-for="(a, idx) in ld.attachment"
                    :key="idx"
                  >
                    <div
                      class="col-md-1 d-flex justify-content-center align-items-center"
                    >
                      &nbsp;
                    </div>
                    <div class="col-md-9 d-flex align-items-start flex-column">
                      <span class="align-middle">{{ a }}</span>
                      <div class="mt-2" v-if="ld.id == 7">
                        <!-- q1 -->
                        <div
                          v-if="
                            Array.isArray(ld.assets[idx].q1) &&
                            ld.assets[idx].q1.length > 0
                          "
                        >
                          <span> File Kontrak : </span>
                          <ul>
                            <!-- If it's an array, print loop of array items as list items -->
                            <li
                              v-for="(file, index) in ld.assets[idx].q1"
                              :key="index"
                            >
                              <a
                                class="text-danger cursor-pointer"
                                @click="viewFile(file)"
                              >
                                {{ "File Kontrak " + (index + 1) }}
                              </a>
                            </li>
                          </ul>
                        </div>

                        <!-- q2 -->
                        <div
                          v-if="
                            Array.isArray(ld.assets[idx].q2) &&
                            ld.assets[idx].q2.length > 0
                          "
                        >
                          <span> File Dokumen Legal : </span>
                          <ul>
                            <!-- If it's an array, print loop of array items as list items -->
                            <li
                              v-for="(file, index) in ld.assets[idx].q2"
                              :key="index"
                            >
                              <a
                                class="text-danger cursor-pointer"
                                @click="viewFile(file)"
                              >
                                {{ "File Dokumen Legal " + (index + 1) }}
                              </a>
                            </li>
                          </ul>
                        </div>

                        <!-- q3 -->
                        <div
                          v-if="
                            Array.isArray(ld.assets[idx].q3) &&
                            ld.assets[idx].q3.length > 0
                          "
                        >
                          <span> File Metode Kerja : </span>
                          <ul>
                            <!-- If it's an array, print loop of array items as list items -->
                            <li
                              v-for="(file, index) in ld.assets[idx].q3"
                              :key="index"
                            >
                              <a
                                class="text-danger cursor-pointer"
                                @click="viewFile(file)"
                              >
                                {{ "File Metode Kerja " + (index + 1) }}
                              </a>
                            </li>
                          </ul>
                        </div>

                        <!-- q4 -->
                        <div
                          v-if="
                            Array.isArray(ld.assets[idx].q4) &&
                            ld.assets[idx].q4.length > 0
                          "
                        >
                          <span>
                            File Identifikasi Bahaya dan Pengendalian Resiko :
                          </span>
                          <ul>
                            <!-- If it's an array, print loop of array items as list items -->
                            <li
                              v-for="(file, index) in ld.assets[idx].q4"
                              :key="index"
                            >
                              <a
                                class="text-danger cursor-pointer"
                                @click="viewFile(file)"
                              >
                                {{
                                  "Identifikasi Bahaya dan Pengendalian Resiko " +
                                  (index + 1)
                                }}
                              </a>
                            </li>
                          </ul>
                        </div>

                        <!-- q5 -->
                        <div
                          v-if="
                            Array.isArray(ld.assets[idx].q5) &&
                            ld.assets[idx].q5.length > 0
                          "
                        >
                          <span> File Daftar pekerja : </span>
                          <ul>
                            <!-- If it's an array, print loop of array items as list items -->
                            <li
                              v-for="(file, index) in ld.assets[idx].q5"
                              :key="index"
                            >
                              <a
                                class="text-danger cursor-pointer"
                                @click="viewFile(file)"
                              >
                                {{ "File Daftar pekerja " + (index + 1) }}
                              </a>
                            </li>
                          </ul>
                        </div>

                        <!-- q6 -->
                        <div
                          v-if="
                            Array.isArray(ld.assets[idx].q6) &&
                            ld.assets[idx].q6.length > 0
                          "
                        >
                          <span> File Daftar sarana prasarana : </span>
                          <ul>
                            <!-- If it's an array, print loop of array items as list items -->
                            <li
                              v-for="(file, index) in ld.assets[idx].q6"
                              :key="index"
                            >
                              <a
                                class="text-danger cursor-pointer"
                                @click="viewFile(file)"
                              >
                                {{
                                  "File Daftar sarana prasarana " + (index + 1)
                                }}
                              </a>
                            </li>
                          </ul>
                        </div>

                        <!-- q7 -->
                        <div
                          v-if="
                            Array.isArray(ld.assets[idx].q7) &&
                            ld.assets[idx].q7.length > 0
                          "
                        >
                          <span> File Standar Operasional Prosedur : </span>
                          <ul>
                            <!-- If it's an array, print loop of array items as list items -->
                            <li
                              v-for="(file, index) in ld.assets[idx].q7"
                              :key="index"
                            >
                              <a
                                class="text-danger cursor-pointer"
                                @click="viewFile(file)"
                              >
                                {{
                                  "File Standar Operasional Prosedur " +
                                  (index + 1)
                                }}
                              </a>
                            </li>
                          </ul>
                        </div>

                        <!-- q8 -->
                        <div
                          v-if="
                            Array.isArray(ld.assets[idx].q8) &&
                            ld.assets[idx].q8.length > 0
                          "
                        >
                          <span> File HSE Plan : </span>
                          <ul>
                            <!-- If it's an array, print loop of array items as list items -->
                            <li
                              v-for="(file, index) in ld.assets[idx].q8"
                              :key="index"
                            >
                              <a
                                class="text-danger cursor-pointer"
                                @click="viewFile(file)"
                              >
                                {{ "File HSE Plan " + (index + 1) }}
                              </a>
                            </li>
                          </ul>
                        </div>

                        <!-- q9 -->
                        <div
                          v-if="
                            Array.isArray(ld.assets[idx].q9) &&
                            ld.assets[idx].q9.length > 0
                          "
                        >
                          <span> File Manajemen Perubahan (MOC) : </span>
                          <ul>
                            <!-- If it's an array, print loop of array items as list items -->
                            <li
                              v-for="(file, index) in ld.assets[idx].q9"
                              :key="index"
                            >
                              <a
                                class="text-danger cursor-pointer"
                                @click="viewFile(file)"
                              >
                                {{
                                  "File Manajemen Perubahan (MOC) " +
                                  (index + 1)
                                }}
                              </a>
                            </li>
                          </ul>
                        </div>

                        <!-- q10 -->
                        <div
                          v-if="
                            Array.isArray(ld.assets[idx].q10) &&
                            ld.assets[idx].q10.length > 0
                          "
                        >
                          <span> File Water Management Plan : </span>
                          <ul>
                            <!-- If it's an array, print loop of array items as list items -->
                            <li
                              v-for="(file, index) in ld.assets[idx].q10"
                              :key="index"
                            >
                              <a
                                class="text-danger cursor-pointer"
                                @click="viewFile(file)"
                              >
                                {{
                                  "File Water Management Plan " + (index + 1)
                                }}
                              </a>
                            </li>
                          </ul>
                        </div>

                        <!-- q11 -->
                        <div
                          v-if="
                            Array.isArray(ld.assets[idx].q11) &&
                            ld.assets[idx].q11.length > 0
                          "
                        >
                          <span> File Hydrocarbon Management Plan : </span>
                          <ul>
                            <!-- If it's an array, print loop of array items as list items -->
                            <li
                              v-for="(file, index) in ld.assets[idx].q11"
                              :key="index"
                            >
                              <a
                                class="text-danger cursor-pointer"
                                @click="viewFile(file)"
                              >
                                {{
                                  "File Hydrocarbon Management Plan " +
                                  (index + 1)
                                }}
                              </a>
                            </li>
                          </ul>
                        </div>

                        <!-- q12 -->
                        <div
                          v-if="
                            Array.isArray(ld.assets[idx].q12) &&
                            ld.assets[idx].q12.length > 0
                          "
                        >
                          <span> File Emergency Response Plan : </span>
                          <ul>
                            <!-- If it's an array, print loop of array items as list items -->
                            <li
                              v-for="(file, index) in ld.assets[idx].q12"
                              :key="index"
                            >
                              <a
                                class="text-danger cursor-pointer"
                                @click="viewFile(file)"
                              >
                                {{
                                  "File Emergency Response Plan " + (index + 1)
                                }}
                              </a>
                            </li>
                          </ul>
                        </div>

                        <!-- q13 -->
                        <div
                          v-if="
                            Array.isArray(ld.assets[idx].q13) &&
                            ld.assets[idx].q13.length > 0
                          "
                        >
                          <span> File Struktur Organisasi Proyek : </span>
                          <ul>
                            <!-- If it's an array, print loop of array items as list items -->
                            <li
                              v-for="(file, index) in ld.assets[idx].q13"
                              :key="index"
                            >
                              <a
                                class="text-danger cursor-pointer"
                                @click="viewFile(file)"
                              >
                                {{
                                  "File Struktur Organisasi Proyek " +
                                  (index + 1)
                                }}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <!-- form non 6 & 7 -->
                    <div
                      class="col-md-2 d-flex justify-content-center align-items-center"
                      v-if="
                        (status == 0 || status == -3) &&
                        ld.realFileName !== null &&
                        ld.realFileName !== '' &&
                        ld.id != 7 &&
                        ld.id != 6
                      "
                    >
                      <!--                    <a @click="removeFile(ld.id,ld.realFileName,ld.idForm)"  class="text-danger text-decoration-none pointer">Remove</a>-->
                      <a
                        style="
                          font-family: 'Inter-Bold';
                          font-size: 1.2rem;
                          color: #dd3737;
                          cursor: pointer;
                        "
                        @click="viewFile(ld.realFileName)"
                        class="text-danger text-decoration-none cursor-pointer"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-eye"
                          style=""
                        /> </a
                      >&nbsp;&nbsp;
                      <a
                        style="
                          font-family: 'Inter-Bold';
                          font-size: 1.2rem;
                          color: #dd3737;
                          cursor: cursor-pointer;
                        "
                        @click="removeFile(ld.id, ld.realFileName, ld.idForm)"
                        class="text-danger text-decoration-none cursor-pointer"
                      >
                        <font-awesome-icon icon="fa-solid fa-trash" style="" />
                      </a>
                    </div>
                    <div
                      class="col-md-2 d-flex justify-content-center align-items-center"
                      v-if="
                        (status == 1 ||
                          status == 2 ||
                          status == 3 ||
                          status == 5 ||
                          status == 6 ||
                          status == 7) &&
                        ld.realFileName !== null &&
                        ld.realFileName !== '' &&
                        ld.id != 7 &&
                        ld.id != 6
                      "
                    >
                      <!--                    <a @click="downloadFile(ld.realFileName, ld.label)"  class="text-danger text-decoration-none pointer">Download</a>-->
                      <a
                        style="
                          font-family: 'Inter-Bold';
                          font-size: 1.2rem;
                          color: #dd3737;
                          cursor: pointer;
                        "
                        @click="downloadFile(ld.realFileName, ld.label)"
                        class="text-danger text-decoration-none cursor-pointer"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-download"
                          style=""
                        />
                      </a>
                    </div>
                    <!-- form 6 -->
                    <template v-if="ld.id == 6">
                      <template v-if="Array.isArray(ld.realFileName)">
                        <div
                          class="col-md-2 d-flex justify-content-center align-items-start"
                          v-if="status == 0 && ld.realFileName[idx] !== null"
                        >
                          <a
                            @click="
                              removeFile(ld.id, ld.realFileName[idx], ld.idForm)
                            "
                            class="text-danger text-decoration-none cursor-pointer"
                            style="font-size: 1.2rem"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-trash"
                              style=""
                            />
                          </a>
                        </div>
                        <div
                          class="col-md-2 d-flex justify-content-center align-items-start"
                          v-if="
                            (status == 1 ||
                              status == 2 ||
                              status == 3 ||
                              status == -3 ||
                              status == 5 ||
                              status == 6 ||
                              status == 7) &&
                            ld.realFileName[idx] !== null &&
                            ld.id == 6
                          "
                        >
                          <!--                            <a @click="downloadFile(ld.realFileName[idx], ld.label)"  class="text-danger text-decoration-none pointer">Download</a>-->
                          <a
                            style="
                              font-family: 'Inter-Bold';
                              font-size: 1.2rem;
                              color: #dd3737;
                              cursor: pointer;
                            "
                            @click="viewFile(ld.realFileName[idx])"
                            class="text-danger text-decoration-none cursor-pointer"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-eye"
                              style=""
                            /> </a
                          >&nbsp;&nbsp;
                          <a
                            style="
                              font-family: 'Inter-Bold';
                              font-size: 1.2rem;
                              color: #dd3737;
                              cursor: pointer;
                            "
                            @click="
                              downloadFile(ld.realFileName[idx], ld.label)
                            "
                            class="text-danger text-decoration-none cursor-pointer"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-download"
                              style=""
                            />
                          </a>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          class="col-md-2 d-flex justify-content-center align-items-start"
                          v-if="status == 0 && ld.realFileName[idx] !== null"
                        >
                          <a
                            @click="
                              removeFile(ld.id, ld.realFileName, ld.idForm)
                            "
                            class="text-danger text-decoration-none cursor-pointer"
                            style="font-size: 1.2rem"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-trash"
                              style=""
                            />
                          </a>
                        </div>
                        <div
                          class="col-md-2 d-flex justify-content-center align-items-start"
                          v-if="
                            (status == 1 ||
                              status == 2 ||
                              status == 3 ||
                              status == -3 ||
                              status == 5 ||
                              status == 6 ||
                              status == 7) &&
                            ld.realFileName[idx] !== null &&
                            ld.id == 6
                          "
                        >
                          <!--                            <a @click="downloadFile(ld.realFileName[idx], ld.label)"  class="text-danger text-decoration-none pointer">Download</a>-->
                          <a
                            style="
                              font-family: 'Inter-Bold';
                              font-size: 1.2rem;
                              color: #dd3737;
                              cursor: pointer;
                            "
                            @click="viewFile(ld.realFileName)"
                            class="text-danger text-decoration-none cursor-pointer"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-eye"
                              style=""
                            /> </a
                          >&nbsp;&nbsp;
                          <a
                            style="
                              font-family: 'Inter-Bold';
                              font-size: 1.2rem;
                              color: #dd3737;
                              cursor: cursor-pointer;
                            "
                            @click="downloadFile(ld.realFileName, ld.label)"
                            class="text-danger text-decoration-none cursor-pointer"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-download"
                              style=""
                            />
                          </a>
                        </div>
                      </template>
                    </template>
                    <!-- form 7 -->
                    <div
                      class="col-md-2 d-flex justify-content-center align-items-start"
                      v-if="
                        ld.realFileName != null &&
                        (status == 0 || status == -3) &&
                        ld.realFileName[idx] !== null &&
                        ld.realFileName[idx] !== '' &&
                        ld.id == 7
                      "
                    >
                      <!--                    <a @click="removeFile(ld.id,ld.realFileName[idx],ld.ids[idx])"  class="text-danger text-decoration-none pointer">Remove</a>-->
                      <a
                        style="
                          font-family: 'Inter-Bold';
                          font-size: 1.2rem;
                          color: #dd3737;
                          cursor: pointer;
                        "
                        @click="viewFile(ld.realFileName[idx])"
                        class="text-danger text-decoration-none cursor-pointer"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-eye"
                          style=""
                        /> </a
                      >&nbsp;&nbsp;
                      <a
                        style="
                          font-family: 'Inter-Bold';
                          font-size: 1.2rem;
                          color: #dd3737;
                          cursor: cursor-pointer;
                        "
                        @click="
                          removeFile(ld.id, ld.realFileName[idx], ld.ids[idx])
                        "
                        class="text-danger text-decoration-none cursor-pointer"
                      >
                        <font-awesome-icon icon="fa-solid fa-trash" style="" />
                      </a>
                    </div>
                    <div
                      class="col-md-2 d-flex justify-content-center align-items-start"
                      v-if="
                        (status == 1 ||
                          status == 2 ||
                          status == 3 ||
                          status == 5 ||
                          status == 6 ||
                          status == 7) &&
                        ld.realFileName[idx] !== null &&
                        ld.realFileName[idx] !== '' &&
                        ld.id == 7
                      "
                    >
                      <!--                    <a @click="downloadFile(ld.realFileName[idx], ld.label)"  class="text-danger text-decoration-none pointer">Download</a>-->
                      <a
                        style="
                          font-family: 'Inter-Bold';
                          font-size: 1.2rem;
                          color: #dd3737;
                          cursor: pointer;
                        "
                        @click="downloadFile(ld.realFileName[idx], ld.label)"
                        class="text-danger text-decoration-none cursor-pointer"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-download"
                          style=""
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <!--div v-else-->
              </div>
            </div>
            <div class="row">
              <div
                class="col-md-12 d-flex justify-content-end"
                v-if="
                  jumlahFileTerpenuhi >= jumlahFile &&
                  (status == 0 || status == -3)
                "
              >
                <button
                  type="button"
                  @click="clickSimpan()"
                  class="btn btn_cari w-25"
                >
                  {{
                    status == 0
                      ? "Submit"
                      : status == -3
                      ? "Submit Ulang"
                      : "Submit"
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div>
              <div
                class="mb-3"
                v-if="(status == 1 || status == -3) && formValues.type != 3"
              >
                <button
                  class="btn btn-danger fs-6 mb-0"
                  style="
                    text-decoration: none;
                    font-weight: 700;
                    cursor: pointer;
                  "
                  data-bs-toggle="modal"
                  data-bs-target="#editKelengkapan"
                >
                  <font-awesome-icon icon="fa-solid fa-edit" />&nbsp;Edit
                  Kelengkapan
                </button>
              </div>
              <div v-if="status == -3">
                <span class="fw-bold">Alasan :</span>
                <p style="white-space: pre-line">{{ alasan }}</p>
                <p>
                  Silahkan update profile perusahaan anda klik
                  <a href="/profile">disini</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
  <!-- modal filter -->
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header flex justify-between items-center">
          <h5 class="modal-title">Upload Dokumen</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="">
            <button
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->

          <div class="row">
            <div class="col-md-12">
              <div class="mb-1">
                <label for="file" class="form-label fs-8 fw-bold"
                  >File Materi Presentasi PJO</label
                >
              </div>
              <div class="input-group mb-1">
                <input
                  type="file"
                  ref="fileMateri"
                  accept=".pdf"
                  class="form-control fs-9"
                  id="inputGroupFile04"
                  @change="handleChangeFile()"
                  aria-describedby="inputGroupFileAddon04"
                  aria-label="Upload"
                  multiple
                />
                <button
                  class="btn btn-outline-secondary fs-9 border border-start-0"
                  type="button"
                  id="inputGroupFileAddon04"
                >
                  <font-awesome-icon
                    icon="fa-solid fa-cloud-arrow-up"
                    style="color: #000000"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0 mt-1">
          <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary">Save changes</button> -->
          <button class="btn btn_cari w-100 fs-8 fw-bold" @click="uploadFiles">
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal345"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header flex justify-between items-center">
          <h5 class="modal-title">Upload Dokumen Form</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="">
            <button
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->

          <div class="row">
            <div class="col-md-12">
              <div class="mb-1">
                <label for="file" class="form-label fs-8 fw-bold"
                  >File Dokumen
                  {{
                    refUploadForm345 == 3
                      ? "Surat Pernyataan Calon PJO"
                      : refUploadForm345 == 4
                      ? "Surat Pernyataan Kebenaran Dokumen"
                      : refUploadForm345 == 5
                      ? "Surat Pernyataan Dukungan Pimpinan Perusahaan"
                      : null
                  }}</label
                >
              </div>
              <div class="input-group mb-1">
                <input
                  type="file"
                  ref="fileDokumen"
                  accept=".pdf"
                  class="form-control fs-9"
                  id="inputGroupFile04"
                  @change="handleChangeFileForm345()"
                  aria-describedby="inputGroupFileAddon04"
                  aria-label="Upload"
                  multiple
                />
                <button
                  class="btn btn-outline-secondary fs-9 border border-start-0"
                  type="button"
                  id="inputGroupFileAddon04"
                >
                  <font-awesome-icon
                    icon="fa-solid fa-cloud-arrow-up"
                    style="color: #000000"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0 mt-1">
          <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary">Save changes</button> -->
          <button
            class="btn btn_cari w-100 fs-8 fw-bold"
            @click="uploadFiles345"
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="modalCatatan"
    tabindex="-1"
    aria-labelledby="modalCatatanLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Catatan</h5>
          <!-- <p>Silahkan Upload berkas anda</p> -->
          <div class="d-flex justify-content-end">
            <button
              ref="closeModalCatatan"
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->
          <p class="fs-8" style="white-space: pre-line">
            {{ catatan }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal modal-lg fade rounded-top-5"
    id="editKelengkapan"
    tabindex="-1"
    aria-labelledby="editKelengkapan"
    aria-hidden="true"
  >
    <div class="modal-dialog-centered rounded-top-5">
      <div
        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
        style="min-height: 156px; min-width: 350px"
      >
        <div
          class="modal-content rounded-bottom-5 rounded-top-4 border-0"
          style="
            min-height: 100px;
            min-width: 350px;
            background: rgba(181, 26, 26, 1);
          "
        >
          <div class="d-flex justify-content-end w-100 p-2">
            <button
              ref="closeModalEditKelengkapan"
              type="button"
              id="btnClose"
              class="btn"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <img
                src="../../assets/icons/close_whaite.png"
                alt="icon"
                width="24"
                height="24"
              />
            </button>
          </div>
          <div
            class="p-3 text-white text-center mb-3"
            style="font-family: Inter, sans-serif"
          >
            <h4 class="fw-bold">Edit Kelengkapan Pengajuan</h4>
          </div>
        </div>
        <div class="modal-body">
          <div class="p-1">
            <form @submit.prevent="OnFormSubmit">
              <div class="row mb-2 mt-1">
                <div class="col-md-12">
                  <p
                    class="mb-2"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    Tipe CoC
                  </p>
                </div>
                <div class="row mb-4">
                  <div class="d-flex justify-content-between fs-8">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="type"
                        value="1"
                        id="coc-1"
                        :checked="formValuesEdit.type == 1"
                        v-model="formValuesEdit.type"
                      />
                      <label class="form-check-label" for="coc-1"
                        >Pengajuan CoC baru</label
                      >
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="type"
                        value="2"
                        id="coc-2"
                        :checked="formValuesEdit.type == 2"
                        v-model="formValuesEdit.type"
                      />
                      <label class="form-check-label" for="coc-2"
                        >Pergantian PJO</label
                      >
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="type"
                        value="3"
                        id="coc-3"
                        :checked="formValuesEdit.type == 3"
                        v-model="formValuesEdit.type"
                      />
                      <label class="form-check-label" for="coc-3"
                        >Update Data CoC</label
                      >
                    </div>
                  </div>
                </div>
                <div :hidden="formValuesEdit.type == 3">
                  <div class="col-md-12">
                    <p
                      class="mb-1"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      Informasi PJO
                    </p>
                  </div>
                  <div class="row mb-4">
                    <div class="col-md-4">
                      <label for="namaPjo" class="form-label fs-8 fw-bold"
                        >Nama PJO
                        <span class="text-danger fs-6">*</span>
                      </label>
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="namaPjo"
                        v-model="formValuesEdit.namaPjo"
                        placeholder="Masukkan Nama PJO"
                      />
                    </div>
                    <div class="col-md-4">
                      <label for="jabatanPjo" class="form-label fs-8 fw-bold"
                        >Jabatan PJO
                        <span class="text-danger fs-6">*</span>
                      </label>
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="jabatanPjo"
                        v-model="formValuesEdit.jabatanPjo"
                        placeholder="Masukkan Jabatan PJO"
                      />
                    </div>
                    <div class="col-md-4">
                      <label for="jabatanPjo" class="form-label fs-8 fw-bold"
                        >Nomor Sertifikat PJO
                        <span class="text-danger fs-6">*</span>
                      </label>
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="jabatanPjo"
                        v-model="formValuesEdit.nomorSertifikatPjo"
                        placeholder="Masukkan Nomor Sertifikat PJO"
                      />
                    </div>
                    <div class="col-md-6">
                      <label
                        for="tandaTanganPjoEdit"
                        class="form-label fs-8 fw-bold text-start"
                      >
                        Tanda Tangan PJO (png, jpg, jpeg)
                        <span
                          v-if="formValuesEdit.fileTtdPjo === ''"
                          class="text-danger fs-6"
                          >*</span
                        >
                      </label>
                      <div
                        v-if="ttdPjoFile != '' && ttdPjoFile != null"
                        class="fs-8"
                      >
                        <img :src="ttdPjoFile" style="height: 5rem" />
                      </div>
                      <div class="input-group mb-1">
                        <input
                          type="file"
                          ref="tandaTanganPjoEdit"
                          accept="image/png, image/jpg, image/jpeg"
                          class="form-control fs-9"
                          id="inputGroupFile04"
                          @change="handleChangeFileSIO('tandaTanganPjoEdit')"
                          aria-describedby="inputGroupFileAddon04"
                          aria-label="Upload"
                        />
                        <button
                          class="btn btn-outline-secondary fs-9 border border-start-0"
                          type="button"
                          id="inputGroupFileAddon04"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-cloud-arrow-up"
                            style="color: #000000"
                          />
                        </button>
                      </div>
                      <div
                        v-if="validasiFileEdit.sizeTtdPjo"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ukuran file melebihi batas (Max: {{ max_file_size }}MB)
                      </div>
                      <div
                        v-if="validasiFileEdit.typeTtdPjo"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ekstensi file tidak sesuai, Mohon tambahkan file Gambar
                        png, jpg, jpeg
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label
                        for="fileSertifikat"
                        class="form-label fs-8 fw-bold text-start"
                      >
                        File Sertifikat Kompetensi Calon PJO
                        <span class="text-danger fs-6">*</span>
                      </label>
                      <div
                        v-if="fileSertifikat != '' && fileSertifikat != null"
                        class="fs-8"
                      >
                        File saat ini :
                        <ul>
                          <li v-for="(asse, idx) in fileSertifikat" :key="idx">
                            <a
                              class="text-danger cursor-pointer"
                              @click="viewFile(asse.filename)"
                              >{{ asse.actual_name }}</a
                            >
                          </li>
                        </ul>
                      </div>
                      <div class="input-group mb-1">
                        <input
                          type="file"
                          ref="fileSertifikatPjoEdit"
                          accept=".pdf"
                          class="form-control fs-9"
                          id="inputGroupFile04"
                          @change="handleChangeFileSIO('fileSertifikatPjoEdit')"
                          aria-describedby="inputGroupFileAddon04"
                          aria-label="Upload"
                        />
                        <button
                          class="btn btn-outline-secondary fs-9 border border-start-0"
                          type="button"
                          id="inputGroupFileAddon04"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-cloud-arrow-up"
                            style="color: #000000"
                          />
                        </button>
                      </div>
                      <div
                        v-if="validasiFile.sizeSertifikatPjo"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ukuran file melebihi batas (Max: {{ max_file_size_sertifikat }}MB)
                      </div>
                      <div
                        v-if="validasiFile.typeSertifikatPjo"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ekstensi file tidak sesuai, Mohon tambahkan file pdf
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <p
                      class="mb-1"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      Informasi Pimpinan Tertinggi Perusahaan
                    </p>
                  </div>
                  <div class="row mb-2">
                    <div class="col-md-6">
                      <label for="namaDireksi" class="form-label fs-8 fw-bold"
                        >Nama Direksi
                        <span class="text-danger fs-6">*</span>
                      </label>
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="namaDireksi"
                        v-model="formValuesEdit.namaAtasan"
                        placeholder="Masukkan Nama Direksi"
                      />
                    </div>
                    <div class="col-md-6">
                      <label
                        for="jabatanDireksi"
                        class="form-label fs-8 fw-bold"
                        >Jabatan Direksi
                        <span class="text-danger fs-6">*</span>
                      </label>
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="jabatanDireksi"
                        v-model="formValuesEdit.jabatanAtasan"
                        placeholder="Masukkan Jabatan Direksi"
                      />
                    </div>
                    <div class="col-md-6">
                      <label
                        for="tandaTanganAtasanEdit"
                        class="form-label fs-8 fw-bold text-start"
                      >
                        Tanda Tangan Direksi (png, jpg, jpeg)
                        <span
                          v-if="formValuesEdit.fileTtdAtasan === ''"
                          class="text-danger fs-6"
                          >*</span
                        >
                      </label>
                      <div
                        v-if="ttdAtasanFile != '' && ttdAtasanFile != null"
                        class="fs-8"
                      >
                        <img :src="ttdAtasanFile" style="height: 5rem" />
                      </div>
                      <div class="input-group mb-1">
                        <input
                          type="file"
                          ref="tandaTanganAtasanEdit"
                          accept="image/png, image/jpg, image/jpeg"
                          class="form-control fs-9"
                          id="inputGroupFile04"
                          @change="handleChangeFileSIO('tandaTanganAtasanEdit')"
                          aria-describedby="inputGroupFileAddon04"
                          aria-label="Upload"
                        />
                        <button
                          class="btn btn-outline-secondary fs-9 border border-start-0"
                          type="button"
                          id="inputGroupFileAddon04"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-cloud-arrow-up"
                            style="color: #000000"
                          />
                        </button>
                      </div>
                      <div
                        v-if="validasiFileEdit.sizeTtdAtasan"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ukuran file melebihi batas (Max: {{ max_file_size }}MB)
                      </div>
                      <div
                        v-if="validasiFileEdit.typeTtdAtasan"
                        class="fs-8 text-danger fst-italic"
                      >
                        Ekstensi file tidak sesuai, Mohon tambahkan file Gambar
                        png, jpg, jpeg
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <button
                  type="submit"
                  class="btn btn-sm bg-danger w-75 text-white"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "../../GlobalDataMixin";
import axios from "axios";
import Swal from "sweetalert2";
import MasterDataStatus from "@/data/status.json";

import {
  API_BASE_URL,
  // CMS_UPLOAD,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_GET_SIOID,
  CMS_SET_SIOID,
  CMS_SIO_GET_DASHBOARD,
  CMS_UPLOAD_USECASE,
  CMS_SIO_SET_PERNYATAANPJO, //form 3
  CMS_SIO_SET_KEBENARAN_DOKUMEN, //form 4
  CMS_SIO_SET_DUKUNGAN_PIMPINAN, //form 5
  CMS_GET_KELENGKAPAN_SIO,
  CMS_SIO_SET_IMKP, //form 7
  CMS_SIO_DEL_PRESENTASI,
  CMS_DOWNLOAD,
  CMS_VIEW_DOCUMENT, //del form 6
  CMS_SIO_SET_KELENGKAPAN,
  CMS_VIEW_IMAGE,
  CMS_UPLOAD_FILE_PK,
  CMS_SET_STATUS_SIO,
  CMS_SET_SIO_CHANGE_TYPE,
  CMS_GET_APP_CONFIGS,
  CMS_SIO_GET_PJOPENGESAHAN,
  CMS_SIO_GET_PJODET,
  CMS_SIO_GET_PERNYATAANPJO,
  CMS_SIO_GET_KEBENARAN_DOKUMEN,
  CMS_SIO_GET_DUKUNGAN_PIMPINAN,
} from "../../constants.js";
import { changeTypeEnum } from "@/utilities/helpers";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import util from "@/assets/js/util";

const url_set_sioid = API_BASE_URL + CMS_SET_SIOID;
const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_set_sio_status = API_BASE_URL + CMS_SET_STATUS_SIO;
const url_get_siodashboard = API_BASE_URL + CMS_SIO_GET_DASHBOARD;
const url_get_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_upload_usecase = API_BASE_URL + CMS_UPLOAD_USECASE;
const url_set_kelengkapan = API_BASE_URL + CMS_SIO_SET_KELENGKAPAN;
const url_upload_file_sertifikat = API_BASE_URL + CMS_UPLOAD_FILE_PK;
const url_get_app_configs = API_BASE_URL + CMS_GET_APP_CONFIGS;

const url_del_form3 = API_BASE_URL + CMS_SIO_SET_PERNYATAANPJO;
const url_del_form4 = API_BASE_URL + CMS_SIO_SET_KEBENARAN_DOKUMEN;
const url_del_form5 = API_BASE_URL + CMS_SIO_SET_DUKUNGAN_PIMPINAN;
const url_del_form6 = API_BASE_URL + CMS_SIO_DEL_PRESENTASI;
const url_del_form7 = API_BASE_URL + CMS_SIO_SET_IMKP;
const url_view_document = API_BASE_URL + CMS_VIEW_DOCUMENT;
const url_get_kelengkapan = API_BASE_URL + CMS_GET_KELENGKAPAN_SIO;
const url_set_sio_change_type = API_BASE_URL + CMS_SET_SIO_CHANGE_TYPE;

const url_get_pjopengesahan = API_BASE_URL + CMS_SIO_GET_PJOPENGESAHAN;
const url_get_pjodetail = API_BASE_URL + CMS_SIO_GET_PJODET;
const url_get_pernyataanpjo = API_BASE_URL + CMS_SIO_GET_PERNYATAANPJO;
const url_get_kebenarandokumen = API_BASE_URL + CMS_SIO_GET_KEBENARAN_DOKUMEN;
const url_get_dukungan = API_BASE_URL + CMS_SIO_GET_DUKUNGAN_PIMPINAN;

const url_download = API_BASE_URL + CMS_DOWNLOAD;
const max_file_size = 5; // MB
const max_file_size_sertifikat = 1.5;

export default {
  mixins: [GlobalDataMixin],
  name: "PraPresentasiPJPBaruPage",
  components: {
    FontAwesomeIcon,
    DefaultLayout,
  },

  mounted() {
    this.loadPage();
  },
  data() {
    return {
      isLoading: true,
      idKelengkapan: null,
      catatan: "",
      listDokumen: [
        {
          id: 1,
          label: "Surat Permohonan Pengesahan PJO",
          statusFile: false,
          linkForm: "/formSuratPermohonanPengesahanPJO",
          type: "form",
          idForm: null,
          reason: "",
          updatedAt: null,
        },
        {
          id: 2,
          label: "Daftar Riwayat Hidup dan Sertifikat",
          statusFile: false,
          linkForm: "/formDaftarRiwayatHidup",
          type: "form",
          idForm: null,
          reason: "",
          updatedAt: null,
        },
        {
          id: 3,
          label: "Surat Pernyataan Calon PJO",
          statusFile: false,
          linkForm: "/formSuratPernyataanCalonPJO",
          type: "formUpload",
          attachment: [],
          realFileName: [],
          idForm: null,
          reason: "",
          updatedAt: null,
        },
        {
          id: 4,
          label: "Surat Pernyataan Kebenaran Dokumen",
          statusFile: false,
          linkForm: "/formSuratPernyataanKebenaranDokumen",
          type: "formUpload",
          attachment: [],
          realFileName: [],
          idForm: null,
          reason: "",
          updatedAt: null,
        },
        {
          id: 5,
          label: "Surat Pernyataan Dukungan Pimpinan Perusahaan",
          statusFile: false,
          linkForm: "/formSuratPernyataanDukungan",
          type: "formUpload",
          attachment: [],
          realFileName: [],
          idForm: null,
          reason: "",
          updatedAt: null,
        },
        {
          id: 6,
          label: "Materi Presentasi PJO",
          statusFile: false,
          linkForm: "",
          type: "upload",
          attachment: [],
          realFileName: [],
          idForm: null,
          reason: "",
        },
        // {id:7,label:"Form IMKP",statusFile:false,linkForm:"/formIMKP",type:"formUpload",attachment:[], realFileName:[], idForm:null, ids:[],assets:null,reason:''},
      ],
      formValues: {
        namaPjo: "",
        jabatanPjo: "",
        namaAtasan: "",
        jabatanAtasan: "",
        fileTtdPjo: "",
        fileTtdAtasan: "",
        nomorSertifikatPjo: "",
        type: "",
      },
      validasiFile: {
        typeTtdPjo: false,
        sizeTtdPjo: false,
        typeTtdAtasan: false,
        sizeTtdAtasan: false,
        typeSertifikatPjo: false,
        sizeSertifikatPjo: false,
      },
      formValuesEdit: {
        namaPjo: "",
        jabatanPjo: "",
        namaAtasan: "",
        jabatanAtasan: "",
        fileTtdPjo: "",
        fileTtdAtasan: "",
        nomorSertifikatPjo: "",
        type: "",
      },
      ttdPjoFile: null,
      ttdAtasanFile: null,
      fileSertifikat: null,
      validasiFileEdit: {
        typeTtdPjo: false,
        sizeTtdPjo: false,
        typeTtdAtasan: false,
        sizeTtdAtasan: false,
      },
      reasondata: {
        reasonDocument: null,
        reasonDocumentDate: null,
        reasonImkp: null,
        reasonImkpDate: null,
      },
      sioID: null,
      jumlahFileTerpenuhi: 0,
      jumlahFile: 6,
      kontraktorName: null,
      kontraktorID: null,
      detailsOpen: [],
      url_icon: "",
      status: 0,
      alasan: null,
      masaBerlaku: null,
      refUploadForm345: null,
      idFormUpload345: null,
      // showttd:""
      tempAssets: null,
      createdSio: null,
      documentComplete: null,
      currentPage: 1,
      reasonNote: [],
      listStatus: [],
      dataStatus: {},
      reminderBeforeDays: 30,
    };
  },
  computed: {
    isExpiringSoon() {
      if (!this.masaBerlaku) return false;
      const expDate = moment(this.masaBerlaku).startOf("day");
      const today = moment().startOf("day");
      const diffDays = expDate.diff(today, "days");
      return diffDays <= this.reminderBeforeDays;
    },
  },
  methods: {
    loadPage() {
      this.kontraktorName = this.userData.kontraktorName;
      this.kontraktorID = parseInt(this.userData.kontraktorID);

      this.getSioID(this.kontraktorID);
      this.getReminderExpCoc();

      if (localStorage.getItem("icon_kontraktor_cms") == null) {
        this.getKontraktor(this.kontraktorID); //get icon
      } else {
        this.url_icon = JSON.parse(
          localStorage.getItem("icon_kontraktor_cms")
        ).icon;
      }

      var x = 0;
      for (let i = 0; i < this.listDokumen.length; i++) {
        if (this.listDokumen[i].statusFile === true) {
          x++;
        }
      }
      this.jumlahFileTerpenuhi = x;
    },
    getReminderExpCoc() {
      axios
        .get(url_get_app_configs, {
          params: {
            module: "COC",
            configKey: "REMINDER-EXP-COC",
          },
          headers: {
            role: this.userData?.role || "kontraktor",
            Authorization: "Bearer " + this.userData?.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          const data = response?.data?.data;
          if (Array.isArray(data) && data.length > 0) {
            const config = data[0];
            if (config?.configValue?.reminder_before_days !== undefined) {
              this.reminderBeforeDays = Number(
                config.configValue.reminder_before_days
              );
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching app config REMINDER-EXP-COC:", error);
        });
    },
    toForm(link) {
      this.$router.push(link);
    },
    onChangeArr(objArr, props, value, id) {
      const obj = objArr.find((x) => x.id === id);
      if (obj) {
        obj[props] = value;
      }

      // this.$forceUpdate();
    },
    validasiForm(action) {
      // console.log(this.fileSertifikat!=null||this.tempAssets!=null)
      if (
        action === "create" &&
        this.formValues.namaPjo != "" &&
        this.formValues.jabatanPjo != "" &&
        this.formValues.namaAtasan != "" &&
        this.formValues.jabatanAtasan != "" &&
        this.$refs.tandaTanganPjo.value != "" &&
        this.$refs.tandaTanganAtasan.value != "" &&
        this.$refs.fileSertifikatPjo.value != "" &&
        this.formValues.nomorSertifikatPjo != ""
      ) {
        return true;
      } else if (
        action == "update" &&
        this.formValuesEdit.namaPjo != "" &&
        this.formValuesEdit.jabatanPjo != "" &&
        this.formValuesEdit.nomorSertifikatPjo != "" &&
        this.formValuesEdit.namaAtasan != "" &&
        this.formValuesEdit.jabatanAtasan != "" &&
        (this.fileSertifikat != null ||
          this.$refs.fileSertifikatPjoEdit.files[0] != null)
      ) {
        return true;
      } else {
        return false;
      }
    },
    clickAjukanSIO() {
      this.isLoading = true;
      this.confirmSetSIO();
    },
    confirmSetSIO() {
      Swal.fire({
        title: "Apakah anda yakin akan menyimpan data ini?",
        showDenyButton: true,
        // showCancelButton: true,
        confirmButtonText: "Iya",
        denyButtonText: `Tidak`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          if (this.formValues.type == 3) {
            this.setSioID();
          } else if (this.validasiForm("create")) {
            this.setSioID();
          } else {
            alert("Lengkapi pengisian form !");
            this.isLoading = false;
          }
        } else if (result.isDenied) {
          this.isLoading = false;
          // Swal.fire("Changes are not saved", "", "info");
          return false;
        }
      });
    },
    setSioID() {
      const tandaTanganPjo = this.$refs.tandaTanganPjo.files[0];
      const tandaTanganAtasan = this.$refs.tandaTanganAtasan.files[0];
      const fileSertifikatPjo = this.$refs.fileSertifikatPjo.files;

      var purs = [];
      var files = [];
      if (tandaTanganPjo != null) {
        purs.push("pjo");
        files.push(tandaTanganPjo);
      }

      if (tandaTanganAtasan != null) {
        purs.push("atasan");
        files.push(tandaTanganAtasan);
      }

      if (fileSertifikatPjo != null) {
        purs.push("sertifikat");
        files.push(fileSertifikatPjo);
      }

      this.isLoading = true;
      let bodyJson = {
        kontraktorId: this.kontraktorID,
        status: this.formValues.type == 3 ? 1 : 0,
        namaPjo: this.formValues.namaPjo,
        jabatanPjo: this.formValues.jabatanPjo,
        namaAtasan: this.formValues.namaAtasan,
        jabatanAtasan: this.formValues.jabatanAtasan,
        nomorSertifikatPjo: this.formValues.nomorSertifikatPjo,
        type: parseInt(this.formValues.type),
        isActive: true,
        perubahan: 0,
      };

      axios
        .post(url_set_sioid, bodyJson, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response setSioID : ", response);

          let ret_sioid = response.data.data.id;
          let id_kelengkapan = response.data.idKelengkapan;
          if (ret_sioid != null && id_kelengkapan != null) {
            this.sioID = ret_sioid;
            this.idKelengkapan = id_kelengkapan;
            if (files.length > 0 && purs.length > 0) {
              this.uploadFilesSio(files, purs, this.idKelengkapan);
            } else {
              this.alertSuksesSioID();
            }
          } else {
            alert("Gagal Create CoC ID!");
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error setSioID : ", error);
          util.showError(error.response.data.status.message);
          // if(error.response.status==500){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }else if(error.response.status==400){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }else if(error.response.status==401){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }
        })
        .then(() => {});
    },
    async uploadFilesSio(files, purs, idForm, action = null) {
      let arrAssets = [];
      for (var x in files) {
        let file = files[x];
        let pur = purs[x];
        if (pur == "sertifikat") {
          for (var y = 0; y < file.length; y++) {
            let fils = file[y];
            if (fils) {
              // Get the file name
              const fileName = fils.name;

              // Create a FormData object and append the file
              const formData = new FormData();
              formData.append("file", fils);
              console.log("filename : ", fileName);
              // Make the API request to upload the file
              try {
                const response = await axios.post(
                  url_upload_file_sertifikat,
                  formData,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data",
                      role: this.userData.role,
                      Authorization: "Bearer " + this.userData.token,
                      accept: "*/*",
                    },
                  }
                );

                // Handle the response from the server as needed
                console.log("response up file sertifikat : ", response);
                console.log("File upload response:", response.data);

                let fname =
                  response.data.filename != "" && response.data.filename != null
                    ? response.data.filename
                    : null;
                let jsonAssets = { actual_name: fileName, filename: fname };
                arrAssets.push(jsonAssets);

                if (y == file.length - 1) {
                  this.tempAssets = JSON.stringify(arrAssets);
                  this.setFileSertifikatPjo();
                }
              } catch (error) {
                // Handle errors, e.g., display an error message to the user
                alert("error");
                // alert(error.message)
                // if (error.response.data != null) {
                //     alert(error.response.data.message)
                // }
                this.isLoading = false;
                console.error("Error uploading file:", error);
                // this.$router.go(this.$router.currentRoute)
              }
            }
          }
        } else {
          if (file) {
            // Get the file name
            const fileName = file.name;

            // Create a FormData object and append the file
            const formData = new FormData();
            formData.append("file", file);
            formData.append("id", idForm);
            formData.append("purpose", pur);
            formData.append("usecase", "kelengkapan");

            // Make the API request to upload the file
            try {
              const response = await axios.post(url_upload_usecase, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  role: this.userData.role,
                  Authorization: "Bearer " + this.userData.token,
                  accept: "*/*",
                },
              });

              // Handle the response from the server as needed
              console.log("File upload response:", response.data);
              console.log("filename : ", fileName);
            } catch (error) {
              // Handle errors, e.g., display an error message to the user
              alert(error.message);
              if (error.response.data != null) {
                alert(error.response.data.message);
              }
              this.isLoading = false;
              console.error("Error uploading file:", error);
              // this.$router.go(this.$router.currentRoute)
            }
          }
        }
      }
      this.alertSuksesSioID(action);
    },
    setFileSertifikatPjo() {
      axios
        .get(url_get_kelengkapan + this.sioID, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          // console.log(response)
          let ret_kel = response.data;

          const tandaTanganPjo = ret_kel.ttdPjo != null ? ret_kel.ttdPjo : null;
          const tandaTanganAtasan =
            ret_kel.ttdAtasan != null ? ret_kel.ttdAtasan : null;

          let bodyJson = {
            id: this.idKelengkapan,
            idSio: this.sioID,
            namaPjo: this.formValues.namaPjo,
            jabatanPjo: this.formValues.jabatanPjo,
            ttdPjo: tandaTanganPjo,
            namaAtasan: this.formValues.namaAtasan,
            jabatanAtasan: this.formValues.jabatanAtasan,
            ttdAtasan: tandaTanganAtasan,
            assets: this.tempAssets,
            nomorSertifikatPjo: this.formValues.nomorSertifikatPjo,
          };
          axios
            .post(url_set_kelengkapan, bodyJson, {
              headers: {
                role: this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            })
            .then((response) => {
              console.log("response setFileSertifikatPjo: ", response);
              // if (filesEdit.length > 0 && pursEdit.length > 0) {
              //   this.uploadFilesSio(filesEdit, pursEdit, this.idKelengkapan, 'update');
              // } else {
              //   this.alertSuksesSioID('update')
              // }
            })
            .catch((error) => {
              console.log("error setFileSertifikatPjo : ", error);
            });
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getKelengkapan : " + error.message);
          console.error("Error fetching data getKelengkapan :", error.message);
        });
    },
    getKelengkapan(sio_id) {
      axios
        .get(url_get_kelengkapan + sio_id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let ret_kel = response.data;
          this.idKelengkapan = ret_kel.id;
          this.formValues.namaPjo = ret_kel.namaPjo;
          this.formValues.jabatanPjo = ret_kel.jabatanPjo;
          this.formValues.namaAtasan = ret_kel.namaAtasan;
          this.formValues.jabatanAtasan = ret_kel.jabatanAtasan;
          this.formValues.fileTtdPjo = ret_kel.ttdPjo;
          this.formValues.fileTtdAtasan = ret_kel.ttdAtasan;
          this.formValues.nomorSertifikatPjo = ret_kel.nomorSertifikatPjo;
          this.tempAssets = ret_kel.assets;
          this.fileSertifikat =
            ret_kel.assets != null && ret_kel.assets != ""
              ? JSON.parse(ret_kel.assets)
              : null;
          this.formValuesEdit = Object.assign({}, this.formValues);
          if (ret_kel.ttdPjo != "" && ret_kel.ttdPjo) {
            this.ttdPjoFile = API_BASE_URL + CMS_VIEW_IMAGE + ret_kel.ttdPjo;
          }
          if (ret_kel.ttdAtasan != "" && ret_kel.ttdAtasan) {
            this.ttdAtasanFile =
              API_BASE_URL + CMS_VIEW_IMAGE + ret_kel.ttdAtasan;
          }
          console.log("assign:", this.formValuesEdit);
          // console.log('fs:',this.fileSertifikat)
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getKelengkapan : " + error.message);
          console.error("Error fetching data getKelengkapan :", error.message);
        });
    },
    getSioID(id) {
      axios
        .get(url_get_sioid + id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response nya = ", response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let dt = null;
          dt = response.data.data;
          if (dt != null) {
            this.sioID = dt.id;
            localStorage.setItem("sio_cms", JSON.stringify({ id: dt.id }));
            this.getSioDashboard(this.sioID);
            this.status = dt.status;
            this.alasan = dt.reason;
            this.masaBerlaku = dt.masaBerlaku;

            this.getKelengkapan(this.sioID);
            this.createdSio = dt.createdAt != null ? dt.createdAt : null;
            this.documentComplete = dt.updatedAt != null ? dt.updatedAt : null;
            this.reasondata = JSON.parse(dt.reasonData);
            this.formValues.type = dt.type;

            this.listStatus = MasterDataStatus.filter((item) =>
              item.type.includes(dt.type)
            );
            this.dataStatus = MasterDataStatus.find(
              (item) => item.status === dt.status
            );
          }

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    getSioDashboard(sio_id) {
      axios
        .get(url_get_siodashboard + sio_id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("getSioDashboard => ", response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let ret_dash = response.data.data;
          let jft = 0;
          // console.log(ret_dash.length)
          let resNote = [];
          if (ret_dash.length > 0) {
            var formIMKP = [];
            var filesIMKP = [];
            var idIMKP = [];
            var assetsIMKP = [];
            for (let i = 0; i < ret_dash.length; i++) {
              if (ret_dash[i].reason != "" && ret_dash[i].reason != null)
                resNote.push(ret_dash[i].reason);

              this.onChangeArr(
                this.listDokumen,
                "statusFile",
                ret_dash[i].formStatus,
                ret_dash[i].idForm
              );
              this.onChangeArr(
                this.listDokumen,
                "reason",
                ret_dash[i].reason != null ? ret_dash[i].reason : "",
                ret_dash[i].idForm
              );
              this.onChangeArr(
                this.listDokumen,
                "updatedAt",
                ret_dash[i].reason != null ? ret_dash[i].updatedAt : "",
                ret_dash[i].idForm
              );
              if (
                ret_dash[i].attachment !== null &&
                ret_dash[i].attachment !== "" &&
                ret_dash[i].idForm != 7
              ) {
                console.log(ret_dash[i].attachment);

                if (ret_dash[i].attachment.length > 1) {
                  // multi file
                  let fn = [];
                  let realfn = [];
                  for (let z = 0; z < ret_dash[i].attachment.length; z++) {
                    if (ret_dash[i].attachment[z] != null) {
                      realfn.push(ret_dash[i].attachment[z]);

                      let file = String(ret_dash[i].attachment[z]).split(".");
                      let extfile = file[1];
                      let index = this.listDokumen.filter(
                        (o) => o.id === ret_dash[i].idForm
                      )[0].id;
                      let filename =
                        this.listDokumen[index - 1].label +
                        " " +
                        (z + 1) +
                        "." +
                        extfile;
                      fn.push(filename);
                    }
                  }
                  this.onChangeArr(
                    this.listDokumen,
                    "attachment",
                    fn,
                    ret_dash[i].idForm
                  );
                  this.onChangeArr(
                    this.listDokumen,
                    "realFileName",
                    realfn,
                    ret_dash[i].idForm
                  );
                } else if (ret_dash[i].attachment.length == 1) {
                  // single file
                  if (
                    ret_dash[i].attachment[0] !== "" &&
                    ret_dash[i].attachment[0] != null
                  ) {
                    let file = String(ret_dash[i].attachment).split(".");
                    let extfile = file[1];
                    let index = this.listDokumen.filter(
                      (o) => o.id === ret_dash[i].idForm
                    )[0].id;
                    let filename =
                      this.listDokumen[index - 1].label + "." + extfile;
                    this.onChangeArr(
                      this.listDokumen,
                      "attachment",
                      [filename],
                      ret_dash[i].idForm
                    );
                    this.onChangeArr(
                      this.listDokumen,
                      "realFileName",
                      ret_dash[i].attachment[0],
                      ret_dash[i].idForm
                    );
                  }
                }
              }

              if (ret_dash[i].idForm == 7) {
                formIMKP.push("IMKP : " + ret_dash[i].name);
                filesIMKP.push(ret_dash[i].attachment[0]);
                idIMKP.push(ret_dash[i].id);
                let object_ass = {
                  q1: null,
                  q2: null,
                  q3: null,
                  q4: null,
                  q5: null,
                  q6: null,
                  q7: null,
                  q8: null,
                  q9: null,
                  q10: null,
                  q11: null,
                  q12: null,
                  q13: null,
                };
                if (ret_dash[i].assets != "" && ret_dash[i].assets != null) {
                  let ass = JSON.parse(ret_dash[i].assets);

                  object_ass.q1 = ass.c_q1;
                  if (ass.c_q1_array != null && ass.c_q1_array != []) {
                    object_ass.q1 = ass.c_q1_array;
                  }

                  object_ass.q2 = ass.c_q2;
                  if (ass.c_q2_array != null && ass.c_q2_array != []) {
                    object_ass.q2 = ass.c_q2_array;
                  }

                  object_ass.q3 = ass.c_q3;
                  if (ass.c_q3_array != null && ass.c_q3_array != []) {
                    object_ass.q3 = ass.c_q3_array;
                  }

                  object_ass.q4 = ass.c_q4;
                  if (ass.c_q4_array != null && ass.c_q4_array != []) {
                    object_ass.q4 = ass.c_q4_array;
                  }

                  object_ass.q5 = ass.c_q5;
                  if (ass.c_q5_array != null && ass.c_q5_array != []) {
                    object_ass.q5 = ass.c_q5_array;
                  }

                  object_ass.q6 = ass.c_q6;
                  if (ass.c_q6_array != null && ass.c_q6_array != []) {
                    object_ass.q6 = ass.c_q6_array;
                  }

                  object_ass.q7 = ass.c_q7;
                  if (ass.c_q7_array != null && ass.c_q7_array != []) {
                    object_ass.q7 = ass.c_q7_array;
                  }

                  object_ass.q8 = ass.c_q8;
                  if (ass.c_q8_array != null && ass.c_q8_array != []) {
                    object_ass.q8 = ass.c_q8_array;
                  }

                  object_ass.q9 = ass.c_q9;
                  if (ass.c_q9_array != null && ass.c_q9_array != []) {
                    object_ass.q9 = ass.c_q9_array;
                  }
                  object_ass.q10 = ass.c_q10;
                  if (ass.c_q10_array != null && ass.c_q10_array != []) {
                    object_ass.q10 = ass.c_q10_array;
                  }
                  object_ass.q11 = ass.c_q11;
                  if (ass.c_q11_array != null && ass.c_q11_array != []) {
                    object_ass.q11 = ass.c_q11_array;
                  }
                  object_ass.q12 = ass.c_q12;
                  if (ass.c_q12_array != null && ass.c_q12_array != []) {
                    object_ass.q12 = ass.c_q12_array;
                  }
                  object_ass.q13 = ass.c_q13;
                  if (ass.c_q13_array != null && ass.c_q13_array != []) {
                    object_ass.q13 = ass.c_q13_array;
                  }
                }
                assetsIMKP.push(object_ass);
                this.onChangeArr(
                  this.listDokumen,
                  "realFileName",
                  filesIMKP,
                  ret_dash[i].idForm
                );
                this.onChangeArr(
                  this.listDokumen,
                  "attachment",
                  formIMKP,
                  ret_dash[i].idForm
                );
                this.onChangeArr(
                  this.listDokumen,
                  "ids",
                  idIMKP,
                  ret_dash[i].idForm
                );
                this.onChangeArr(
                  this.listDokumen,
                  "assets",
                  assetsIMKP,
                  ret_dash[i].idForm
                );
                console.log(idIMKP);
                console.log("hasil akhir = ", this.listDokumen);
              }

              // set value id form
              if (ret_dash[i].id != null) {
                // let index = this.listDokumen.filter(o => o.id===ret_dash[i].idForm)[0].id;
                this.onChangeArr(
                  this.listDokumen,
                  "idForm",
                  ret_dash[i].id,
                  ret_dash[i].idForm
                );
              }

              if (ret_dash[i].formStatus == true && ret_dash[i].idForm != 7) {
                jft++;
              }
            }
            this.reasonNote = resNote;
            this.jumlahFileTerpenuhi = jft;
            // this.jumlahFileTerpenuhi = jft;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },

    getKontraktor(id) {
      axios
        .get(url_get_kontraktor + id, {
          headers: { accept: "application/json" },
        })
        .then((response) => {
          console.log(response);
          // this.kontraktor = response.data.detailKontraktor
          // set value form edit
          // this.url_icon = API_BASE_URL+CMS_VIEW_IMAGE+response.data.detailKontraktor.image;
          if (
            response.data.detailKontraktor.image != null ||
            response.data.detailKontraktor.image != ""
          ) {
            localStorage.setItem(
              "icon_kontraktor_cms",
              JSON.stringify({ icon: response.data.detailKontraktor.image })
            );
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data Detail Kontraktor : " + error.message);
          console.error("Error fetching data:", error.message);
        });
    },
    alertSuksesSioID(action = null) {
      this.isLoading = false;
      let title = !action
        ? "Create CoC ID Sukses"
        : "Update Data Kelengkapan Sukses";
      let text = !action
        ? "CoC ID berhasil diubah untuk Kontraktor Anda"
        : "Data Kelengkapan berhasil diubah untuk Kontraktor Anda";
      Swal.fire({
        title: title,
        text: text,
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        // this.$router.back()
        window.location.reload();
      });
    },
    alertSukses() {
      Swal.fire({
        title: "Berhasil",
        text: "Berhasil simpan!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        // this.$refs.closeModal.click();
        // this.$router.back()
        this.$router.go();
      });
    },
    alertSuksesPublishSio() {
      const title =
        this.formValues.type == 1
          ? "Pengajuan CoC Sukses"
          : "Pengajuan pergantian PJO Sukses";
      const description =
        this.formValues.type == 1
          ? "Pengajuan CoC Anda berhasil di Simpan !"
          : "Pengajuan pergantian PJO Anda berhasil di Simpan !";
      Swal.fire({
        title: title,
        text: description,
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        window.location.reload();
        // this.$router.back()
      });
    },
    handleChangeFileSIO(refFile) {
      let file = null;

      if (refFile == "tandaTanganPjo") {
        file = this.$refs.tandaTanganPjo.files[0];
        if (file) {
          // Check file type
          if (
            file.type !== "image/jpg" &&
            file.type !== "image/jpeg" &&
            file.type !== "image/png"
          ) {
            this.validasiFile.typeTtdPjo = true;
            this.validasiFile.sizeTtdPjo = false;
            this.$refs.tandaTanganPjo.value = "";
            return;
          }

          // Check file size ({{max_file_size}}MB limit)
          if (file.size > max_file_size * 1024 * 1024) {
            this.validasiFile.typeTtdPjo = false;
            this.validasiFile.sizeTtdPjo = true;
            this.$refs.tandaTanganPjo.value = "";
            return;
          }

          // Reset error messages if the file is valid
          this.validasiFile.typeTtdPjo = false;
          this.validasiFile.sizeTtdPjo = false;

          // Handle the valid file as needed (e.g., store the file)
          console.log("Valid file:", file);
        }
      } else if (refFile == "tandaTanganAtasan") {
        file = this.$refs.tandaTanganAtasan.files[0];
        if (file) {
          // Check file type
          if (
            file.type !== "image/jpg" &&
            file.type !== "image/jpeg" &&
            file.type !== "image/png"
          ) {
            this.validasiFile.typeTtdAtasan = true;
            this.validasiFile.sizeTtdAtasan = false;
            this.$refs.tandaTanganAtasan.value = "";
            return;
          }

          // Check file size ({{max_file_size}}MB limit)
          if (file.size > max_file_size * 1024 * 1024) {
            this.validasiFile.typeTtdAtasan = false;
            this.validasiFile.sizeTtdAtasan = true;
            this.$refs.tandaTanganAtasan.value = "";
            return;
          }

          // Reset error messages if the file is valid
          this.validasiFile.typeTtdAtasan = false;
          this.validasiFile.sizeTtdAtasan = false;

          // Handle the valid file as needed (e.g., store the file)
          console.log("Valid file:", file);
        }
      } else if (refFile == "fileSertifikatPjo") {
        let files = this.$refs.fileSertifikatPjo.files;

        if (files) {
          for (let x = 0; x < files.length; x++) {
            let file = files[x];
            // Check file type
            if (file.type !== "application/pdf") {
              this.validasiFile.typeSertifikatPjo = true;
              this.validasiFile.sizeSertifikatPjo = false;
              this.$refs.fileSertifikatPjo.value = "";
              return;
            }

            // Check file size ({{max_file_size}}MB limit)
            if (file.size > max_file_size_sertifikat * 1024 * 1024) {
              this.validasiFile.typeSertifikatPjo = false;
              this.validasiFile.sizeSertifikatPjo = true;
              this.$refs.fileSertifikatPjo.value = "";
              return;
            }

            // Reset error messages if the file is valid
            this.validasiFile.typeSertifikatPjo = false;
            this.validasiFile.sizeSertifikatPjo = false;

            // Handle the valid file as needed (e.g., store the file)
            console.log("Valid file:", file);
          }
        }
      } else if (refFile == "tandaTanganPjoEdit") {
        file = this.$refs.tandaTanganPjoEdit.files[0];
        if (file) {
          // Check file type
          if (
            file.type !== "image/jpg" &&
            file.type !== "image/jpeg" &&
            file.type !== "image/png"
          ) {
            this.validasiFile.typeTtdPjo = true;
            this.validasiFile.sizeTtdPjo = false;
            this.$refs.tandaTanganPjoEdit.value = "";
            return;
          }

          // Check file size ({{max_file_size}}MB limit)
          if (file.size > max_file_size * 1024 * 1024) {
            this.validasiFile.typeTtdPjo = false;
            this.validasiFile.sizeTtdPjo = true;
            this.$refs.tandaTanganPjoEdit.value = "";
            return;
          }

          // Reset error messages if the file is valid
          this.validasiFile.typeTtdPjo = false;
          this.validasiFile.sizeTtdPjo = false;

          // Handle the valid file as needed (e.g., store the file)
          console.log("Valid file:", file);
        }
      } else if (refFile == "tandaTanganAtasanEdit") {
        file = this.$refs.tandaTanganAtasanEdit.files[0];
        if (file) {
          // Check file type
          if (
            file.type !== "image/jpg" &&
            file.type !== "image/jpeg" &&
            file.type !== "image/png"
          ) {
            this.validasiFile.typeTtdAtasan = true;
            this.validasiFile.sizeTtdAtasan = false;
            this.$refs.tandaTanganAtasanEdit.value = "";
            return;
          }

          // Check file size ({{max_file_size}}MB limit)
          if (file.size > max_file_size * 1024 * 1024) {
            this.validasiFile.typeTtdAtasan = false;
            this.validasiFile.sizeTtdAtasan = true;
            this.$refs.tandaTanganAtasanEdit.value = "";
            return;
          }

          // Reset error messages if the file is valid
          this.validasiFile.typeTtdAtasan = false;
          this.validasiFile.sizeTtdAtasan = false;

          // Handle the valid file as needed (e.g., store the file)
          console.log("Valid file:", file);
        }
      } else if (refFile == "fileSertifikatPjoEdit") {
        let files = this.$refs.fileSertifikatPjoEdit.files;
        if (files) {
          for (let x = 0; x < files.length; x++) {
            let file = files[x];
            // Check file type
            if (file.type !== "application/pdf") {
              this.validasiFile.typeSertifikatPjo = true;
              this.validasiFile.sizeSertifikatPjo = false;
              this.$refs.fileSertifikatPjoEdit.value = "";
              return;
            }

            // Check file size ({{max_file_size}}MB limit)
            if (file.size > max_file_size_sertifikat * 1024 * 1024) {
              this.validasiFile.typeSertifikatPjo = false;
              this.validasiFile.sizeSertifikatPjo = true;
              this.$refs.fileSertifikatPjoEdit.value = "";
              return;
            }

            // Reset error messages if the file is valid
            this.validasiFile.typeSertifikatPjo = false;
            this.validasiFile.sizeSertifikatPjo = false;

            // Handle the valid file as needed (e.g., store the file)
            console.log("Valid file:", file);
          }
        }
      }
    },
    handleChangeFile345(reffile) {
      // alert('reffile');
      console.log("reffile345:", this.$refs[reffile]);
    },

    handleChangeFile() {
      let files = this.$refs.fileMateri.files;
      for (let x = 0; x < files.length; x++) {
        let file = files[x];
        if (file) {
          // Check file type
          console.log(file.type != "application/pdf");
          if (file.type != "application/pdf") {
            this.$refs.fileMateri.value = "";
            alert("Ekstensi tidak sesuai pada " + file.name);
            return;
          }

          // Check file size ({{max_file_size}}MB limit)
          if (file.size > max_file_size * 1024 * 1024) {
            this.$refs.fileMateri.value = "";
            alert(
              "Ukuran file " +
                file.name +
                " melebihi batas ukuran file " +
                max_file_size +
                "MB"
            );
            return;
          }

          // Handle the valid file as needed (e.g., store the file)
          // console.log('Valid file:', file);
        }
      }
    },
    async uploadFiles() {
      this.isLoading = true;
      let files = this.$refs.fileMateri.files;
      for (let x = 0; x < files.length; x++) {
        let file = files[x];
        if (file) {
          // Get the file name
          const fileName = file.name;

          // Create a FormData object and append the file
          const formData = new FormData();
          formData.append("file", file);
          formData.append("id", this.sioID);
          formData.append("purpose", "form6");
          formData.append("usecase", "form6");
          // Make the API request to upload the file
          try {
            const response = await axios.post(url_upload_usecase, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                role: this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            });

            // Handle the response from the server as needed
            console.log("File upload response:", response.data);
            console.log("filename : ", fileName);
          } catch (error) {
            // Handle errors, e.g., display an error message to the user
            alert(error.message);
            if (error.response.data != null) {
              alert(error.response.data.message);
            }
            this.isLoading = false;
            console.error("Error uploading file:", error);
            // this.$router.go(this.$router.currentRoute)
          }
        }
      }

      if (
        this.reasondata != null &&
        this.reasondata.reasonDocument != null &&
        this.reasondata.reasonDocument != ""
      ) {
        this.getSioBuatHapusReason(); // buat proses hapus reason document
      } else {
        this.alertSuksesUpload();
      }
    },
    alertSuksesUpload() {
      Swal.fire({
        title: "Upload File Materi Sukses",
        text: "File Materi Presentasi PJO berhasil disimpan !",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        this.$router.go();
        // this.isLoading = false;
      });
    },

    alertSuksesDeleteFile() {
      Swal.fire({
        title: "Delete File",
        text: "File Berhasil dihapus !",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        this.$router.go();
        // this.isLoading = false;
      });
    },

    removeFile(idrefform, filename, idform) {
      Swal.fire({
        title: "Apakah Anda yakin akan menghapus dokumen ini ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          let url = null;
          let bodyJson = {};
          let methods = "post";
          if (idrefform == 3) {
            url = url_del_form3;
            bodyJson = {
              id: idform,
              idSio: this.sioID,
              attachmentFile: filename,
              attachmentDelete: true,
            };
          } else if (idrefform == 4) {
            url = url_del_form4;
            bodyJson = {
              id: idform,
              idSio: this.sioID,
              attachmentFile: filename,
              attachmentDelete: true,
            };
          } else if (idrefform == 5) {
            url = url_del_form5;
            bodyJson = {
              id: idform,
              idSio: this.sioID,
              attachmentFile: filename,
              attachmentDelete: true,
            };
          } else if (idrefform == 6) {
            url = url_del_form6;
            methods = "delete";
          } else if (idrefform == 7) {
            url = url_del_form7;
            bodyJson = {
              id: idform,
              idSio: this.sioID,
              // "attachment": filename,
              isDeleteAttachment: true,
            };
          }

          if (url != null) {
            if (methods == "post") {
              axios
                .post(url, bodyJson, {
                  headers: {
                    role: this.userData.role,
                    Authorization: "Bearer " + this.userData.token,
                    accept: "*/*",
                  },
                })
                .then((response) => {
                  console.log("response delete file : ", response);
                  this.alertSuksesDeleteFile();

                  this.isLoading = false;
                  window.location.reload();
                })
                .catch((error) => {
                  this.isLoading = false;
                  console.log("error delete file : ", error);
                  alert("error delete file");
                });
            } else if (methods == "delete") {
              axios
                .delete(url + idform, {
                  headers: {
                    role: this.userData.role,
                    Authorization: "Bearer " + this.userData.token,
                    accept: "*/*",
                  },
                })
                .then((response) => {
                  console.log("delete file : ", response);
                  this.alertSuksesDeleteFile();
                  this.isLoading = false;
                  window.location.reload();
                })
                .catch((error) => {
                  this.isLoading = false;
                  console.error(error);
                  alert("error delete file");
                });
            }
          }
        }
      });
    },
    getSioBuatHapusReason() {
      axios
        .get(url_get_sioid + this.kontraktorID, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          // this.statusSio = response.data.data.status;

          if (response.data.data.reasonData != null) {
            this.reasondata = JSON.parse(response.data.data.reasonData);
          }
          this.reasondata.reasonDocument = "";
          this.hapusReason();
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    hapusReason() {
      let bodyJsonRD = {
        id: this.sioID,
        reasonData: JSON.stringify(this.reasondata),
        type: this.formValues.type,
      };
      axios
        .post(url_set_sioid, bodyJsonRD, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response rejectSio : ", response);
          this.alertSuksesUpload();
          // this.status = 1;
          // this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error rejectSio : ", error);
          util.showError(error.response.data.status.message);
        })
        .then(() => {});
    },
    downloadTemplate(idform) {
      let url_download_template = "";
      if (idform == 3) {
        url_download_template = "/printFormSuratPernyataanCalonPJO";
      } else if (idform == 4) {
        url_download_template = "/printFormSuratPernyataanKebenaranDokumen";
      } else if (idform == 5) {
        url_download_template = "/printFormSuratPernyataanDukungan";
      }
      window.open(url_download_template, "_blank");
    },
    popUploadFileDokumen(refform, idform) {
      this.refUploadForm345 = refform;
      this.idFormUpload345 = idform;
    },
    downloadFile(filename, label) {
      axios
        .get(url_download + filename, { responseType: "blob" })
        .then((response) => {
          this.handleFileDownload(response.data, filename, label);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    },
    handleFileDownload(blobData, filename, label) {
      var dateNow = moment(new Date()).format("DDMMYYYY");
      // Create a Blob from the response data
      const blob = new Blob([blobData], { type: "application/octet-stream" });
      // Create a link element and trigger a download
      const link = document.createElement("a");
      console.log(filename);
      link.href = window.URL.createObjectURL(blob);
      link.download = label + "_" + dateNow + ".pdf"; // Set the desired file name
      link.click();
    },
    async clickSimpan() {
      try {
        const checkSync = await this.checkSyncData();
        if (!checkSync.every((item) => item.is_valid)) {
          const formNotValid = checkSync.filter((data) => !data.is_valid);
          const formIds = formNotValid.map((item) => item.id).join(", ");

          util.showError(
            `Dokumen (persyaratan nomor ${formIds}) harus dicek terlebih dulu.!`
          );
          return;
        } else {
          const result = await Swal.fire({
            title: "Apakah Anda yakin akan simpan data pengajuan CoC ini ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya",
          });

          if (result.isConfirmed) {
            this.isLoading = true;
            this.submitSio();
          }
        }
      } catch (err) {
        console.error("ERR clickSimpan:", err);
      }
    },
    async checkSyncData() {
      const response = [
        {
          id: 1,
          is_valid: false,
        },
        {
          id: 2,
          is_valid: false,
        },
        {
          id: 3,
          is_valid: false,
        },
        {
          id: 4,
          is_valid: false,
        },
        {
          id: 5,
          is_valid: false,
        },
      ];
      try {
        const form = await axios.get(url_get_siodashboard + this.sioID, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });

        for (const item of form.data.data) {
          if (item.idForm === 1 && item.id) {
            const res = await axios.get(url_get_pjopengesahan + item.id, {
              headers: {
                role: this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            });

            const result = res.data.data;

            if (
              this.formValues.namaPjo === result.nama &&
              this.formValues.jabatanPjo === result.jabatan &&
              this.formValues.namaAtasan === result.namaPemimpin &&
              this.formValues.jabatanAtasan === result.jabatanPemimpin
            ) {
              response.forEach((item) => {
                if (item.id === 1) item.is_valid = true;
              });
            } else {
              response.forEach((item) => {
                if (item.id === 1) item.is_valid = false;
              });
            }
          } else if (item.idForm === 2 && item.id) {
            const res = await axios.get(url_get_pjodetail + item.id, {
              headers: {
                role: this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            });

            const result = res.data.data;

            if (
              this.formValues.namaPjo === result.nama &&
              this.formValues.jabatanPjo === result.jabatan
            ) {
              response.forEach((item) => {
                if (item.id === 2) item.is_valid = true;
              });
            } else {
              response.forEach((item) => {
                if (item.id === 2) item.is_valid = false;
              });
            }
          } else if (item.idForm === 3 && item.id) {
            const res = await axios.get(url_get_pernyataanpjo + item.id, {
              headers: {
                role: this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            });

            const result = res.data.data;

            if (
              this.formValues.namaPjo === result.namaCalon &&
              this.formValues.jabatanPjo === result.jabatan &&
              this.formValues.namaPjo === result.namaPengesah
            ) {
              response.forEach((item) => {
                if (item.id === 3) item.is_valid = true;
              });
            } else {
              response.forEach((item) => {
                if (item.id === 3) item.is_valid = false;
              });
            }
          } else if (item.idForm === 4 && item.id) {
            const res = await axios.get(url_get_kebenarandokumen + item.id, {
              headers: {
                role: this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            });

            const result = res.data.data;

            if (
              this.formValues.namaPjo === result.namaPengesah &&
              this.formValues.namaAtasan === result.namaPengesahPemimpin
            ) {
              response.forEach((item) => {
                if (item.id === 4) item.is_valid = true;
              });
            } else {
              response.forEach((item) => {
                if (item.id === 4) item.is_valid = false;
              });
            }
          } else if (item.idForm === 5 && item.id) {
            const res = await axios.get(url_get_dukungan + item.id, {
              headers: {
                role: this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            });

            const result = res.data.data;

            if (
              this.formValues.namaPjo === result.namaPjo &&
              this.formValues.jabatanPjo === result.jabatanPjo &&
              this.formValues.namaAtasan === result.namaPimpinan &&
              this.formValues.jabatanAtasan === result.jabatanPimpinan
            ) {
              response.forEach((item) => {
                if (item.id === 5) item.is_valid = true;
              });
            } else {
              response.forEach((item) => {
                if (item.id === 5) item.is_valid = false;
              });
            }
          }
        }

        return response;
      } catch (err) {
        return response;
      }
    },
    submitSio() {
      let bodyJsonProfile = {
        kontraktorId: this.kontraktorID,
        action: "publish",
        id: this.sioID,
        type: parseInt(this.formValues.type),
      };
      axios
        .post(url_set_sioid, bodyJsonProfile, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response submitSio : ", response);
          this.alertSuksesPublishSio();
          this.status = 1;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error submitSio : ", error);
          util.showError(error.response.data.status.message);
        })
        .then(() => {});
    },
    viewFile(fileName) {
      window.open(url_view_document + fileName, "_blank");
    },
    lihatCatatan(note) {
      this.catatan = note;
    },
    handleChangeFileForm345() {
      let file = this.$refs.fileDokumen.files[0];
      // console.log('Valid file:', file);
      if (file) {
        // Check file type
        if (file.type !== "application/pdf") {
          alert("Ekstensi file harus .pdf!");
          this.$refs.fileDokumen.value = "";
          return;
        }

        // Check file size ({{max_file_size}}MB limit)
        if (file.size > max_file_size * 1024 * 1024) {
          alert("Ukuran file melebihi batas max " + max_file_size + "MB !");
          this.$refs.fileDokumen.value = "";
          return;
        }

        // Reset error messages if the file is valid

        // Handle the valid file as needed (e.g., store the file)
        console.log("Valid file:", file);
      }
    },
    async uploadFiles345() {
      this.isLoading = true;
      let usec = null;
      let purp = null;
      let file = this.$refs.fileDokumen.files[0];
      if (this.refUploadForm345 == 3) {
        purp = "attachment";
        usec = "ttd_form3";
      } else if (this.refUploadForm345 == 4) {
        purp = "attachment";
        usec = "ttd_form4";
      } else if (this.refUploadForm345 == 5) {
        purp = "attachment";
        usec = "ttd_form5";
      }
      if (file) {
        // Get the file name
        const fileName = file.name;

        // Create a FormData object and append the file
        const formData = new FormData();
        formData.append("file", file);
        formData.append("id", this.idFormUpload345);
        formData.append("purpose", purp);
        formData.append("usecase", usec);

        // Make the API request to upload the file
        try {
          const response = await axios.post(url_upload_usecase, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              role: this.userData.role,
              Authorization: "Bearer " + this.userData.token,
              accept: "*/*",
            },
          });
          this.alertSuksesUploadDokumen();
          // Handle the response from the server as needed
          console.log("File upload response:", response.data);
          console.log("filename : ", fileName);
        } catch (error) {
          // Handle errors, e.g., display an error message to the user
          alert(error.message);
          if (error.response.data != null) {
            alert(error.response.data.message);
          }
          this.isLoading = false;
          console.error("Error uploading file:", error);
          // this.$router.go(this.$router.currentRoute)
        }
      } else {
        alert("File dokumen belum ditambahkan!");
        this.isLoading = false;
      }
    },
    alertSuksesUploadDokumen() {
      this.isLoading = false;
      Swal.fire({
        title: "Upload Dokumen",
        text:
          "Upload File Dokumen " + this.refUploadForm345 == 3
            ? "Surat Pernyataan Calon PJO"
            : this.refUploadForm345 == 4
            ? "Surat Pernyataan Kebenaran Dokumen"
            : this.refUploadForm345 == 5
            ? "Surat Pernyataan Dukungan Pimpinan Perusahaan"
            : "Surat Pernyataan Calon PJO" + " berhasil !",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        window.location.reload();
      });
    },
    OnFormSubmit() {
      this.isLoading = true;
      this.confirmUpdateKelengkapan();
    },
    confirmUpdateKelengkapan() {
      Swal.fire({
        title: "Apakah anda yakin akan menyimpan perubahan data?",
        showDenyButton: true,
        // showCancelButton: true,
        confirmButtonText: "Iya",
        denyButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$refs.closeModalEditKelengkapan.click();
          if (this.validasiForm("update") || this.formValuesEdit.type == 3) {
            let file = this.$refs.fileSertifikatPjoEdit.files[0];
            if (file != null) {
              this.uploadEditFileSertifikat();
            } else {
              this.updateKelengkapan();
            }
          } else {
            alert("Lengkapi pengisian form !");
            this.isLoading = false;
          }
        } else if (result.isDenied) {
          this.isLoading = false;
          // Swal.fire("Changes are not saved", "", "info");
          return false;
        }
      });
    },
    async uploadEditFileSertifikat() {
      let files = this.$refs.fileSertifikatPjoEdit.files;
      // let arrAssets = this.tempAssets!=null?JSON.parse(this.tempAssets):[];
      let arrAssets = [];

      if (files) {
        for (var y = 0; y < files.length; y++) {
          let file = files[y];
          if (file) {
            // Get the file name
            const fileName = file.name;

            // Create a FormData object and append the file
            const formData = new FormData();
            formData.append("file", file);
            console.log("filename : ", fileName);
            // Make the API request to upload the file
            try {
              const response = await axios.post(
                url_upload_file_sertifikat,
                formData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    role: this.userData.role,
                    Authorization: "Bearer " + this.userData.token,
                    accept: "*/*",
                  },
                }
              );

              // Handle the response from the server as needed
              console.log("response up file sertifikat : ", response);
              console.log("File upload response:", response.data);

              let fname =
                response.data.filename != "" && response.data.filename != null
                  ? response.data.filename
                  : null;
              let jsonAssets = { actual_name: fileName, filename: fname };
              arrAssets.push(jsonAssets);

              if (y == files.length - 1) {
                this.tempAssets = JSON.stringify(arrAssets);
                this.updateKelengkapan();
              }
            } catch (error) {
              // Handle errors, e.g., display an error message to the user
              alert("error");
              // alert(error.message)
              // if (error.response.data != null) {
              //     alert(error.response.data.message)
              // }
              this.isLoading = false;
              console.error("Error uploading file:", error);
              // this.$router.go(this.$router.currentRoute)
            }
          }
        }
      }
    },
    updateKelengkapan() {
      const tandaTanganPjoEdit = this.$refs.tandaTanganPjoEdit.files[0];
      const tandaTanganAtasanEdit = this.$refs.tandaTanganAtasanEdit.files[0];

      let pursEdit = [];
      let filesEdit = [];
      if (tandaTanganPjoEdit != null) {
        pursEdit.push("pjo");
        filesEdit.push(tandaTanganPjoEdit);
      }

      if (tandaTanganAtasanEdit != null) {
        pursEdit.push("atasan");
        filesEdit.push(tandaTanganAtasanEdit);
      }

      this.isLoading = true;

      let bodyJson = {
        id: this.idKelengkapan,
        idSio: this.sioID,
        namaPjo: this.formValuesEdit.namaPjo,
        jabatanPjo: this.formValuesEdit.jabatanPjo,
        ttdPjo: tandaTanganPjoEdit
          ? tandaTanganPjoEdit.name
          : this.formValues.fileTtdPjo,
        namaAtasan: this.formValuesEdit.namaAtasan,
        jabatanAtasan: this.formValuesEdit.jabatanAtasan,
        ttdAtasan: tandaTanganAtasanEdit
          ? tandaTanganAtasanEdit.name
          : this.formValues.fileTtdAtasan,
        assets: this.tempAssets,
        nomorSertifikatPjo: this.formValuesEdit.nomorSertifikatPjo,
      };

      axios
        .post(url_set_kelengkapan, bodyJson, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response simpanEditKelengkapan: ", response);
          this.updateStatusSIO();
          if (filesEdit.length > 0 && pursEdit.length > 0) {
            this.uploadFilesSio(
              filesEdit,
              pursEdit,
              this.idKelengkapan,
              "update"
            );
          } else {
            this.alertSuksesSioID("update");
          }
        })
        .catch((error) => {
          console.log("error simpanEditProfile : ", error);
        });
    },
    updateStatusSIO() {
      this.isLoading = true;
      let bodyJson = {
        status:
          this.formValuesEdit.type == 3
            ? 1
            : this.reasonNote.length > 0
            ? -3
            : 0,
        id: this.sioID,
        type: this.formValuesEdit.type,
      };
      axios
        .post(url_set_sio_status, bodyJson, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response update status sio : ", response);
          // this.dataNC = response.data.data;
          // this.alertSuksesSioID('update')
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error updateStatusSIO : ", error);
        })
        .then(() => {});
    },
    redirectToLink(link, id) {
      window.open(link + id, "_blank");
    },
    movePage(page) {
      if (
        (this.currentPage <= 2 && page === -1) ||
        (this.currentPage === 1 && page === 1)
      ) {
        this.currentPage += page;
        // document.querySelector('.body-form-wizard .pagination .active')?.classList.remove('active')
        // document.querySelectorAll('.body-form-wizard .pagination .number')[this.currentPage - 1]?.classList.add('active')
        const stepNode = document.querySelector(
          ".body-form-wizard .steps .step"
        );
        const width = (this.currentPage - 1) * stepNode.offsetWidth * -1 + "px";
        stepNode.parentNode.style.marginLeft = width;
      }
    },
    handleButtonClick() {
      if (this.currentPage === 2 || this.formValues.type == 3) {
        this.clickAjukanSIO();
      } else {
        this.movePage(1);
      }
    },
    changeType(type) {
      Swal.fire({
        title: "Konfirmasi",
        html:
          type === changeTypeEnum.PERGANTIAN
            ? "Apakah yakin untuk melakukan pergantian PJO pada CoC?"
            : type === changeTypeEnum.PERPANJANG
            ? "Apakah yakin untuk melakukan perpanjangan CoC? Apabila terdapat perubahan data profile untuk keperluan review CoC, Anda dapat mengubahnya melalui fitur <a href='/profile' style='color:#0d6efd; text-decoration:underline; font-weight:600'>Update Profile Kontraktor disini</a>."
            : type === changeTypeEnum.UPDATEDATA
            ? "Apakah yakin untuk melakukan perubahan data CoC? Apabila terdapat perubahan data profile untuk keperluan review CoC, Anda dapat mengubahnya melalui fitur <a href='/profile' style='color:#0d6efd; text-decoration:underline; font-weight:600'>Update Profile Kontraktor disini</a>."
            : "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#198754",
        cancelButtonColor: "#dd3737",
        confirmButtonText: "Ya!",
        cancelButtonText: "Batal",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          let bodyJson = {
            idSio: this.sioID,
            type: null,
          };

          if (type === changeTypeEnum.PERPANJANG) {
            bodyJson.type = 1;
          } else if (type === changeTypeEnum.PERGANTIAN) {
            bodyJson.type =
              this.formValues.type == 1 ? 2 : this.formValues.type == 2 ? 6 : 5;
          } else if (type === changeTypeEnum.UPDATEDATA) {
            bodyJson.type = 3;
          }
          axios
            .post(url_set_sio_change_type, bodyJson, {
              headers: {
                role: "kontraktor",
                Authorization: "Bearer " + this.userData.token,
                accept: "application/json",
              },
            })
            .then(() => {
              this.alertSukses();
            })
            .catch((error) => {
              console.log(error);
              this.isLoading = false;
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Terjadi kesalahan!",
              });
            });
        }
      });
    },
  },
};
</script>

<style scoped>
section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}

.btn_eform {
  background-color: #fff;
  border: #d0d5dd;
}
.body-form-wizard {
  overflow: hidden;
}
.body-form-wizard .pagination {
  gap: 15px;
}
.body-form-wizard .pagination .number {
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
  background: #dd3737;
}
.body-form-wizard .pagination .bar {
  width: 30rem;
  height: 4px;
  background: #dd3737;
  border-radius: 5px;
}
.body-form-wizard .pagination .active ~ div {
  background: #ddd !important;
  color: #111;
}
.steps {
  width: 200%;
  transition: all 300ms ease-in-out;
}
.steps .step {
  overflow: hidden;
}
.steps .step .grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}
.steps .step .grid .col {
  width: 50%;
  justify-self: center;
}
.steps .step .grid .col label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}
.steps .step .grid .col input {
  width: 100%;
  padding: 8px;
  border: 1px solid #bbb;
  border-radius: 8px;
}
.steps .step .grid .col .checkbox input {
  display: none;
}
.steps .step .grid .col .checkbox label {
  border: 1px solid #bbb;
  border-radius: 5px;
  margin: 0;
  cursor: pointer;
}
.steps .step .grid .col .checkbox input:checked + label {
  background: #dd3737;
  color: #fff;
}
</style>
